/* Silný Kafe – theme scripts (no dependencies) */
(function () {
  'use strict';

  var strings = (window.theme && window.theme.strings) || {};
  var routes = (window.theme && window.theme.routes) || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
      var locale = document.documentElement.lang || 'cs';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html) {
    var el = $('#CartToast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- App widgets (e.g. Shopify Inbox chat): hide while the cart drawer is open ----------
     Anything an app appends directly to <body> is hidden, whatever it is called; the theme's own
     elements (sections, main, skip link, toast, scripts) are left alone. */
  var THEME_BODY_CHILDREN = '.skip-link, .shopify-section, [id^="shopify-section"], main, .toast, #MenuDrawer, .toolbar-cover, script, style, link, noscript, template';
  // Page scroll lock while a drawer is open. overflow:hidden on body alone doesn't stop iOS Safari from scrolling the
  // page under the drawer, so the body is pinned in place (and put back at the same scroll position on unlock);
  // the class also switches off pull-to-refresh meanwhile (base.css)
  var lockCount = 0, lockY = 0, toolbarCover = null;
  function lockScroll() {
    if (lockCount++) return;
    lockY = window.scrollY;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
    document.documentElement.classList.add('is-scroll-locked');
    // iOS Safari shows the page through its bottom toolbar, where the drawer (a fixed layer) doesn't reach: at the top of
    // the home page that is the dark hero photo, a strip under the menu's bar. A plain block in the page, right under
    // the visible screen and in the drawers' bottom colour, covers it while a drawer is open
    if (!toolbarCover) {
      toolbarCover = document.createElement('div');
      toolbarCover.className = 'toolbar-cover';
      toolbarCover.setAttribute('aria-hidden', 'true');
      document.body.appendChild(toolbarCover);
    }
    // From mid-screen down: Safari's toolbar can sit over the page (innerHeight then reaches under it)
    toolbarCover.style.top = (lockY + Math.round(window.innerHeight / 2)) + 'px';
  }
  function unlockScroll() {
    if (!lockCount || --lockCount) return;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.overflow = '';
    var html = document.documentElement, smooth = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockY);
    html.style.scrollBehavior = smooth;
    // Unlocked only after jumping back, so the header doesn't take the jump for scrolling down
    requestAnimationFrame(function () { requestAnimationFrame(function () { html.classList.remove('is-scroll-locked'); }); });
    if (toolbarCover) { toolbarCover.remove(); toolbarCover = null; }
  }

  function toggleChat(hidden) {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el.matches(THEME_BODY_CHILDREN)) return;
      if (hidden) {
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      } else {
        el.style.removeProperty('opacity');
        el.style.removeProperty('visibility');
        el.style.removeProperty('pointer-events');
      }
    });
  }

  /* ---------- Height of everything above <main> (announcement + header), used by the hero to fill the screen ---------- */
  function setAboveMain() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var top = main.getBoundingClientRect().top + window.scrollY;
    document.documentElement.style.setProperty('--above-main', Math.round(top) + 'px');
    var header = document.querySelector('[data-header]');
    if (header) {
      // The sticky section keeps the full header height even while the floating pill is shrunk
      var box = header.classList.contains('is-sticky') && header.closest('.section-header') || header;
      document.documentElement.style.setProperty('--header-h', Math.round(box.offsetHeight) + 'px');
    }
  }
  setAboveMain();
  window.addEventListener('load', setAboveMain);
  window.addEventListener('resize', setAboveMain);

  /* ---------- Header: drawer, search, scroll shadow ---------- */
  function initHeader() {
    var drawer = $('#MenuDrawer');
    // The menu lives in the header section, which slides on phones; there iOS Safari won't tint its bottom toolbar
    // from it (a dark strip showed under the menu's bar). Straight under <body>, like the cart drawer, it does.
    // Left in place in the theme editor, which re-renders the header section with it
    if (drawer && drawer.parentNode !== document.body && !(window.Shopify && window.Shopify.designMode)) document.body.appendChild(drawer);
    var openBtn = $('[data-drawer-open]');
    var lastFocus;

    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
      var wasOpen = drawer.dataset.locked === '1';
      if (open && !wasOpen) { lockScroll(); drawer.dataset.locked = '1'; }
      if (!open && wasOpen) { unlockScroll(); drawer.dataset.locked = ''; }
      // Like the cart: hiding/showing the chat layer makes iOS Safari re-tint its bottom toolbar after closing
      toggleChat(open);
      if (open) {
        // Measure after the slide-in, once the list has its final height
        setTimeout(updateMore, 350);
        lastFocus = document.activeElement;
        var first = $('.drawer__close', drawer);
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    // Very short screens: if the menu doesn't fit, show "Posuňte pro další" at the bottom until the end is reached
    var menuBody = drawer && $('.drawer__body', drawer);
    function updateMore() {
      if (!menuBody) return;
      var more = menuBody.scrollHeight - menuBody.clientHeight - menuBody.scrollTop > 8;
      menuBody.classList.toggle('has-more', more);
    }
    if (menuBody) {
      menuBody.addEventListener('scroll', updateMore, { passive: true });
      window.addEventListener('resize', updateMore);
    }

    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });

    var search = $('#SearchModal');
    var searchBtn = $('[data-search-open]');
    function setSearch(open) {
      if (!search) return;
      search.hidden = !open;
      if (searchBtn) searchBtn.setAttribute('aria-expanded', String(open));
      if (open) { var i = $('input[type="search"]', search); if (i) i.focus(); }
    }
    if (searchBtn) searchBtn.addEventListener('click', function () { setSearch(search.hidden); });
    $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      setDrawer(false);
      setSearch(false);
    });

    var header = $('[data-header]');
    if (header) {
      // Phones: sticky header hides while scrolling down, comes back on scroll up
      var section = header.closest('.section-header');
      var hideOnScroll = header.classList.contains('is-sticky') && section;
      var mobile = window.matchMedia('(max-width: 989px)');
      var lastY = window.scrollY;
      // Floating header: lock the section to its full (unscrolled) height so the pill
      // can shrink on scroll without moving the page
      // Measuring briefly puts the header in another state; .is-frozen turns transitions off until the
      // real state has been restyled, so restoring it never animates (a visible blink)
      var freeze = function () { header.classList.add('is-frozen'); };
      var unfreeze = function () { void header.offsetWidth; header.classList.remove('is-frozen'); };
      var lockHeight = function () {
        if (!hideOnScroll) return;
        freeze();
        section.style.height = '';
        header.classList.add('is-measuring');
        section.style.height = section.offsetHeight + 'px';
        header.classList.remove('is-measuring');
        unfreeze();
        setAboveMain();
      };
      // Desktop pill: measure the width of its content so the shrink can animate
      var measurePill = function () {
        if (!hideOnScroll || mobile.matches) return;
        freeze();
        var was = header.classList.contains('is-scrolled');
        header.classList.add('is-scrolled', 'is-measuring-pill');
        header.style.setProperty('--pill-w', Math.ceil(header.querySelector('.header').getBoundingClientRect().width) + 'px');
        if (!was) header.classList.remove('is-scrolled');
        header.classList.remove('is-measuring-pill');
        unfreeze();
      };
      // Desktop menu that doesn't fit on one line (narrow window, longer translations): use the tablet
      // layout with the menu button instead. Measured on the full header: logo + menu + icons vs. its width
      var bar = header.querySelector('.header');
      var nav = bar && bar.querySelector('.header__nav ul');
      var fitNav = function () {
        if (!nav) return;
        if (mobile.matches) { bar.classList.remove('header--compact'); return; }
        var was = header.classList.contains('is-scrolled');
        freeze();
        header.classList.remove('is-scrolled');
        bar.classList.remove('header--compact');
        var cs = getComputedStyle(bar);
        var gap = parseFloat(cs.columnGap) || 0;
        var room = bar.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 2 * gap
          - bar.querySelector('.header__logo').offsetWidth - bar.querySelector('.header__icons').offsetWidth
          - parseFloat(getComputedStyle(nav.parentNode).paddingLeft);
        bar.classList.toggle('header--compact', nav.scrollWidth > room);
        if (was) header.classList.add('is-scrolled');
        unfreeze();
      };
      var onResize = function () { fitNav(); lockHeight(); measurePill(); };
      onResize();
      // Re-measure only once resizing stops: measuring briefly switches the header between its states,
      // which flickered while dragging the window edge
      var resizeTimer;
      window.addEventListener('resize', function () {
        document.documentElement.classList.add('is-resizing');
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { onResize(); document.documentElement.classList.remove('is-resizing'); }, 150);
      });
      window.addEventListener('load', onResize);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitNav(); measurePill(); });
      var pillTimer, settleTimer;
      var onScroll = function () {
        // While the menu or cart is open the page is pinned (scrollY reads 0) and on closing it jumps back: neither is
        // the visitor scrolling, so the header stays as it was (and lastY keeps the real position)
        if (document.documentElement.classList.contains('is-scroll-locked')) return;
        var y = window.scrollY;
        if (!hideOnScroll || !mobile.matches) {
          header.classList.toggle('is-scrolled', y > 10);
        } else {
          // Phones: hide as soon as the page scrolls down and switch to the floating pill only
          // while off-screen, so the header never morphs and then slides away (a visible blink).
          // The pill shows up when scrolling back up.
          var menuOpen = header.querySelector('[aria-expanded="true"]');
          if (y <= 10) {
            section.classList.remove('header-hidden');
            if (header.classList.contains('is-scrolled')) {
              // Animate the pill back into the full-width header (the logo grows smoothly)
              header.classList.add('is-settling');
              header.classList.remove('is-scrolled');
              clearTimeout(settleTimer);
              settleTimer = setTimeout(function () { header.classList.remove('is-settling'); }, 350);
            }
          } else if (menuOpen || y < lastY - 6) {
            section.classList.remove('header-hidden');
          } else if (y > lastY && !section.classList.contains('header-hidden')) {
            section.classList.add('header-hidden');
            clearTimeout(pillTimer);
            pillTimer = setTimeout(function () {
              if (section.classList.contains('header-hidden')) header.classList.add('is-scrolled');
            }, 320);
          }
          if (y > 10 && !section.classList.contains('header-hidden') && !header.classList.contains('is-scrolled')) {
            // Scrolled back up before the hidden header had turned into the pill (it is still partly on-screen):
            // morph into the pill smoothly instead of snapping
            clearTimeout(pillTimer);
            header.classList.add('is-settling', 'is-scrolled');
            clearTimeout(settleTimer);
            settleTimer = setTimeout(function () { header.classList.remove('is-settling'); }, 350);
          }
        }
        lastY = y;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Hero featured coffee: show it once the visitor starts scrolling ---------- */
  // Move each picks carousel to the next coffee that isn't in the cart yet (stays put if all are)
  // Move each picks carousel on to a coffee not in the cart yet. After an add (smooth), when every coffee there is
  // already in the cart, it still moves on, so the one just added isn't what shows next. only: limit to some carousels
  function advanceHeroPicks(smooth, only) {
    document.querySelectorAll('[data-hero-pick]').forEach(function (pick) {
      if (only && !only(pick)) return;
      var track = pick.querySelector('[data-hero-pick-track]');
      if (!track || track.children.length < 2) return;
      var slides = Array.prototype.slice.call(track.children);
      var w = slides[1].offsetLeft - slides[0].offsetLeft;
      if (!w) return;
      var cur = Math.round(track.scrollLeft / w);
      var inCart = function (li) {
        if (li.querySelector('.cart-suggest__add.is-added, .card__wt.is-in-cart, .card__add.has-count')) return true;
        return Array.prototype.some.call(li.querySelectorAll('[data-wt-qty]'), function (wt) { return (parseInt(wt.dataset.wtQty, 10) || 0) > 0; });
      };
      if (!inCart(slides[cur])) return;
      for (var k = 1; k < slides.length; k++) {
        var i = (cur + k) % slides.length;
        if (!inCart(slides[i])) { track.scrollTo({ left: i * w, behavior: smooth ? 'smooth' : 'auto' }); return; }
      }
      if (pick.dataset.justAdded) track.scrollTo({ left: ((cur + 1) % slides.length) * w, behavior: smooth ? 'smooth' : 'auto' });
    });
    document.querySelectorAll('[data-hero-pick][data-just-added]').forEach(function (pick) {
      if (!only || only(pick)) delete pick.dataset.justAdded;
    });
  }

  function initHeroPick() {
    var picks = document.querySelectorAll('[data-hero-pick]');
    if (!picks.length) return;
    picks.forEach(function (pick) {
      // Carousel: dots follow the swipe; dots and arrows jump to a coffee
      var track = pick.querySelector('[data-hero-pick-track]');
      var dots = pick.querySelectorAll('[data-hero-pick-dot]');
      if (!track || !dots.length) return;
      var step = function () { var a = track.children[0], b = track.children[1]; return b ? b.offsetLeft - a.offsetLeft : track.clientWidth; };
      var current = function () { return Math.round(track.scrollLeft / Math.max(1, step())); };
      var go = function (i) {
        var n = track.children.length;
        track.scrollTo({ left: ((i % n) + n) % n * step(), behavior: 'smooth' });
      };
      track.addEventListener('scroll', function () {
        var i = current();
        dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }, { passive: true });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.heroPickDot, 10)); }); });
      pick.querySelectorAll('[data-hero-pick-step]').forEach(function (b) {
        b.addEventListener('click', function () { go(current() + parseInt(b.dataset.heroPickStep, 10)); });
      });
    });
    // A coffee already in the cart shouldn't be the first thing shown
    advanceHeroPicks(false);
    // Desktop card fades in shortly after load; on phones/tablets the card shows once the visitor scrolls
    var desktop = document.querySelector('.hero-pick--desktop');
    if (desktop) setTimeout(function () { desktop.classList.add('is-shown'); }, 700);
    var mobile = document.querySelector('.hero-pick--mobile');
    if (!mobile) return;
    var reveal = function () {
      if (window.scrollY < 8) return;
      mobile.classList.add('is-shown');
      window.removeEventListener('scroll', reveal);
    };
    window.addEventListener('scroll', reveal, { passive: true });
    reveal();
  }


  /* ---------- Country & language dropdowns (desktop header, mobile menu) ---------- */
  function initLangMenu() {
    $$('[data-lang-menu]').forEach(initOneLangMenu);
    // The language button shows the language icon for a moment twice per visit (4 s after the first page loads, then
    // 12 s later) and never again in that visit, nor ever for someone who has switched the language. It stops once the
    // visitor points at or opens it, and never runs with reduced motion; a hidden tab waits until it is visible again
    var flips = $$('.loc-pair:not(.loc-pair--full) .loc-menu--language .loc-menu__flip');
    var mem = function (store, k, v) { try { if (v === undefined) return store.getItem(k); store.setItem(k, v); } catch (e) { return null; } };
    document.addEventListener('click', function (e) { if (e.target.closest('[name="locale_code"]')) mem(localStorage, 'sk-lang-switched', '1'); });
    if (flips.length && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      && !mem(localStorage, 'sk-lang-switched') && !mem(sessionStorage, 'sk-lang-flipped')) {
      mem(sessionStorage, 'sk-lang-flipped', '1');
      var stopped = false, stop = function () { stopped = true; };
      flips.forEach(function (f) { var t = f.closest('.loc-menu__toggle'); t.addEventListener('pointerenter', stop); t.addEventListener('click', stop); t.addEventListener('focus', stop); });
      var flipOnce = function () {
        if (stopped) return;
        if (document.hidden) { document.addEventListener('visibilitychange', function again() { document.removeEventListener('visibilitychange', again); setTimeout(flipOnce, 1000); }); return; }
        flips.forEach(function (f) { f.closest('.loc-menu__toggle').classList.add('is-flip'); });
        setTimeout(function () { flips.forEach(function (f) { f.closest('.loc-menu__toggle').classList.remove('is-flip'); }); }, 1500);
      };
      setTimeout(flipOnce, 4000);
      setTimeout(flipOnce, 16000);
    }
  }
  function initOneLangMenu(menu) {
    var toggle = menu.querySelector('[data-lang-menu-toggle]');
    var pop = menu.querySelector('.lang-menu__pop');
    // Country/language pair: the dropdown hangs right under its own button (or above it when there is no room
    // below), lined up with the button's left edge, or its right edge when it would run off the screen
    var own = menu.classList.contains('loc-menu');
    function place() {
      var st = pop.style;
      st.top = st.bottom = st.left = st.right = '';
      // The room is the screen, or the box that clips the dropdown (the mobile menu panel on a tablet)
      var gap = 8, minX = 0, maxX = document.documentElement.clientWidth, maxY = window.innerHeight, minY = 0;
      for (var el = menu.parentElement; el && el !== document.body; el = el.parentElement) {
        var cs = getComputedStyle(el);
        if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
          var cr = el.getBoundingClientRect();
          minX = Math.max(minX, cr.left); maxX = Math.min(maxX, cr.right); minY = Math.max(minY, cr.top); maxY = Math.min(maxY, cr.bottom);
          break;
        }
      }
      var t = toggle.getBoundingClientRect(), box = menu.getBoundingClientRect();
      var w = pop.offsetWidth, h = pop.offsetHeight;
      var below = maxY - t.bottom, above = t.top - minY;
      if (h + gap * 2 > below && above > below) { st.top = 'auto'; st.bottom = (box.bottom - t.top + gap) + 'px'; }
      else { st.bottom = 'auto'; st.top = (t.bottom - box.top + gap) + 'px'; }
      if (t.left + w > maxX - gap) { st.left = 'auto'; st.right = Math.max(0, box.right - t.right) + 'px'; }
      else { st.right = 'auto'; st.left = (t.left - box.left) + 'px'; }
      var r = pop.getBoundingClientRect();
      if (r.right > maxX - gap) { st.left = 'auto'; st.right = (box.right - (maxX - gap)) + 'px'; r = pop.getBoundingClientRect(); }
      if (r.left < minX + gap) { st.right = 'auto'; st.left = (minX + gap - box.left) + 'px'; }
    }
    function setOpen(open) {
      pop.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open && own) place();
    }
    if (own) window.addEventListener('resize', function () { if (!pop.hidden) place(); });
    toggle.addEventListener('click', function () {
      var open = pop.hidden;
      setOpen(open);
      if (open) { var current = pop.querySelector('[aria-current="true"]') || pop.querySelector('button'); if (current) current.focus({ preventScroll: true }); }
    });
    document.addEventListener('click', function (e) { if (!pop.hidden && !menu.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) { setOpen(false); toggle.focus(); }
    });
    menu.addEventListener('focusout', function (e) { if (!pop.hidden && e.relatedTarget && !menu.contains(e.relatedTarget)) setOpen(false); });
  }

  /* ---------- Cart drawer ---------- */
  var CART_SECTION = 'cart-drawer';
  var cartDrawerLastFocus;

  function cartDrawer() { return $('[data-cart-drawer]'); }

  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = count > 0 ? count : ''; });
  }

  // Bundle circles: how many there are / are filled, so a re-render can animate only what changed
  function goalState(root) {
    var box = $('.bundle-progress', root);
    if (!box) return null;
    return {
      slots: $$('.bundle-progress__slot', box).length,
      filled: $$('.bundle-progress__slot.is-filled', box).length,
      done: box.classList.contains('bundle-progress--done')
    };
  }

  function animateGoal(before, root) {
    var box = $('.cart-drawer__goal .bundle-progress', root);
    if (!box || !before) return;
    if (box.classList.contains('bundle-progress--done')) {
      if (!before.done) box.classList.add('is-entering');
      return;
    }
    $$('.bundle-progress__slot', box).forEach(function (slot, i) {
      if (i >= before.slots) {
        // The bundle grew from 3 to 5: the extra circles pop in one after another
        slot.classList.add('is-new');
        slot.style.animationDelay = (0.15 + (i - before.slots) * 0.12) + 's';
      } else if (i >= before.filled && slot.classList.contains('is-filled')) {
        slot.classList.add('is-filling');
      }
    });
  }

  // Rewards cards (bundle circles, free shipping bar): what was shown before a re-render, so only the change animates
  function rewardsState(root) {
    var box = $('[data-cart-rewards]', root);
    if (!box) return null;
    var bar = $('[data-reward-bar]', box);
    return { on: $$('[data-reward="bundle"] .cart-reward__dot.is-on', box).length, bar: bar ? parseFloat(bar.dataset.rewardBar) || 0 : null };
  }
  function animateRewards(before, root) {
    var box = $('[data-cart-rewards]', root);
    if (!box || !before) return;
    // A circle just filled pops in; the bar grows (or shrinks) from where it was
    $$('[data-reward="bundle"] .cart-reward__dot.is-on', box).forEach(function (dot, i) {
      if (i >= before.on) dot.classList.add('is-new');
    });
    var bar = $('[data-reward-bar]', box);
    if (bar && before.bar !== null) {
      var to = bar.style.width;
      bar.style.transition = 'none';
      bar.style.width = before.bar + '%';
      void bar.offsetWidth;
      bar.style.transition = '';
      bar.style.width = to;
    }
  }

  // Replace the drawer contents with freshly rendered section HTML
  function renderCartDrawer(sectionHtml) {
    if (!sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = $('[data-cart-drawer-inner]');
    if (!fresh || !current) return;
    var before = goalState(current);
    var rewardsBefore = rewardsState(current);
    current.replaceWith(fresh);
    applyMax(fresh);
    animateGoal(before, fresh);
    animateRewards(rewardsBefore, fresh);
    setCartCount(parseInt(fresh.dataset.cartCountValue, 10) || 0);
  }

  function openCartDrawer() {
    var drawer = cartDrawer();
    if (!drawer) return false;
    cartDrawerLastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (drawer.dataset.locked !== '1') { lockScroll(); drawer.dataset.locked = '1'; }
    toggleChat(true);
    var close = $('.cart-drawer__header [data-cart-drawer-close]', drawer);
    if (close) close.focus();
    return true;
  }

  var pickAdvancePending = false;
  function closeCartDrawer() {
    var drawer = cartDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (pickAdvancePending) {
      pickAdvancePending = false;
      // The menu's picks are out of sight: move them on right away, so the next coffee is there when the menu opens
      var inMenu = function (pick) { return !!pick.closest('#MenuDrawer'); };
      advanceHeroPicks(false, inMenu);
      setTimeout(function () { advanceHeroPicks(true, function (pick) { return !inMenu(pick); }); }, 1000);
    }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    // Notices are for the moment: gone once the cart is closed ("+" stays switched off where it was)
    $$('.cart-sub__note', drawer).forEach(function (n) { n.remove(); });
    var errBox = $('[data-cart-drawer-error]', drawer);
    if (errBox) errBox.textContent = '';
    if (drawer.dataset.locked === '1') { unlockScroll(); drawer.dataset.locked = ''; }
    toggleChat(false);
    if (cartDrawerLastFocus) cartDrawerLastFocus.focus();
  }

  function changeCartLine(line, quantity, trigger) {
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.classList.add('is-loading');
    // The weight row behind the button, so a "not enough in stock" answer can be shown right under it
    var isPlus = !!(trigger && trigger.matches && trigger.matches('.qty [data-line-change]:last-of-type'));
    var sub = trigger && trigger.closest ? trigger.closest('.cart-sub') : null;
    var subVariant = sub && sub.dataset.cartVariant;
    var subProduct = sub && sub.closest('[data-cart-product]') ? sub.closest('[data-cart-product]').dataset.cartProduct : null;
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: CART_SECTION, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || strings.error);
        renderCartDrawer(r.data.sections && r.data.sections[CART_SECTION]);
        // One more (or one fewer) of a weight: the coffee lights up again; a check when a bag was added, "−1" when one was taken
        if (quantity > 0 && subProduct) highlightCartLine(subProduct, subVariant, false, !isPlus);
        // A coffee removed from the cart turns back into an "add" button in the picks cards
        syncPicks(r.data.items);
      })
      .catch(function (err) {
        var current = $('[data-cart-drawer-inner]');
        var box = $('[data-cart-drawer-error]');
        if (!isPlus || !subVariant || !subProduct) {
          if (current) current.classList.remove('is-loading');
          if (box) box.textContent = err.message || strings.error;
          return;
        }
        // More than is in stock (Shopify may have set the line to the most it has): refresh the cart so the quantity
        // is right, then the note, red cross and switched-off "+" go on that weight's row instead of the top
        fetch(window.location.pathname + '?section_id=' + CART_SECTION, { headers: { Accept: 'text/html' } })
          .then(function (res) { return res.text(); })
          .then(function (html) { renderCartDrawer(html); })
          .catch(function () {})
          .then(function () {
            var cur = $('[data-cart-drawer-inner]');
            if (cur) cur.classList.remove('is-loading');
            var b = $('[data-cart-drawer-error]');
            if (b) b.textContent = '';
            highlightCartLine(subProduct, subVariant, true);
            syncPicksFromCart();
          });
      });
  }

  // Picks buttons (hero, desktop card, menu): "+" to add, or a check with the number of bags in the cart (opens the cart)
  function setPickState(b, qty) {
    qty = qty > 0 ? qty : 0;
    if (String(qty) === b.dataset.pickQty && (qty > 0) === b.classList.contains('is-added')) return;
    b.dataset.pickQty = qty;
    if (qty > 0) {
      var check = document.querySelector('[data-hero-pick-check]');
      b.innerHTML = (check ? check.innerHTML : '') + b.dataset.addedLabel;
      var tag = document.createElement('span');
      tag.className = 'card__count';
      tag.textContent = qty;
      b.appendChild(tag);
      b.classList.add('is-added');
      b.removeAttribute('aria-label');
      b.removeAttribute('data-quick-add');
      b.setAttribute('data-cart-drawer-open', '');
    } else {
      b.textContent = b.dataset.addLabel;
      b.classList.remove('is-added');
      b.setAttribute('aria-label', b.dataset.addAria);
      b.setAttribute('data-quick-add', b.dataset.pickVariant);
      b.removeAttribute('data-cart-drawer-open');
    }
  }
  // Phones' floating buy pill: "+ Do košíku" until the picked bag is in the cart, then "− n +" for it (the cart opens
  // after adding, so there is no separate confirmation here)
  var buyBarQty = {};
  function renderBuyBar() {
    var bar = document.querySelector('[data-buy-bar]');
    if (!bar) return;
    var n = buyBarQty[bar.dataset.variant] || 0;
    var btn = bar.querySelector('[data-buy-bar-button]'), pill = bar.querySelector('[data-buy-bar-qty]');
    bar.querySelector('[data-buy-bar-n]').textContent = n;
    btn.hidden = n > 0; pill.hidden = n === 0;
    if (!btn.disabled) btn.textContent = btn.dataset.label;
  }
  function syncBuyBar(items) {
    var bar = document.querySelector('[data-buy-bar]');
    if (!bar || !items) return;
    buyBarQty = {};
    var bags = 0;
    items.forEach(function (it) { buyBarQty[it.variant_id] = (buyBarQty[it.variant_id] || 0) + it.quantity; bags += it.quantity; });
    renderBuyBar();
    // Only when one coffee is missing for the bigger bundle (5 coffees): "Ještě 1 káva pro slevu 10 %"
    var nudge = bar.querySelector('[data-buy-bar-nudge]');
    if (nudge && nudge.dataset.size2) {
      var size = parseInt(nudge.dataset.size2, 10), disc = nudge.dataset.discount2;
      var left = size - bags;
      if (left === 1) {
        var tpl = left === 1 ? nudge.dataset.one : (left < 5 ? nudge.dataset.few : nudge.dataset.many);
        // The same circles as the bundle box in the cart: one per coffee, filled ones are in the cart
        var dots = '<span class="buy-bar__dots" aria-hidden="true">';
        for (var i = 1; i <= size; i++) dots += '<i' + (i <= bags ? ' class="is-filled"' : '') + '></i>';
        nudge.innerHTML = dots + '</span>' + tpl.replace(/__N__/g, left).replace(/__D__/g, disc);
        nudge.hidden = false;
      } else nudge.hidden = true;
    }
  }
  function buyBarStep(btn) {
    var bar = btn.closest('[data-buy-bar]'), pill = bar.querySelector('[data-buy-bar-qty]');
    if (pill.classList.contains('is-busy')) return;
    var variant = bar.dataset.variant, n = buyBarQty[variant] || 0, step = parseInt(btn.dataset.buyBarStep, 10) > 0 ? 1 : -1;
    if (step > 0 && btn.getAttribute('aria-disabled') === 'true') { briefMaxNote(btn); return; }
    pill.classList.add('is-busy');
    var url = step > 0 ? routes.cart_add_url : routes.cart_change_url;
    var body = step > 0 ? { items: [{ id: parseInt(variant, 10), quantity: 1 }] } : { id: String(variant), quantity: Math.max(0, n - 1) };
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        pill.classList.remove('is-busy');
        if (!r.ok) {
          // No more in stock: "+" switches off and says why
          if (step > 0) { rememberMax(variant, n); btn.setAttribute('aria-disabled', 'true'); briefMaxNote(btn); }
          else toast(r.data.description || r.data.message || strings.error);
          return;
        }
        if (cartDrawer()) renderCartDrawer(r.data.sections && r.data.sections[CART_SECTION]);
        if (step < 0) bar.querySelector('[data-buy-bar-step="1"]').removeAttribute('aria-disabled');
        syncPicksFromCart();
        fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); }).then(function (c) { setCartCount(c.item_count); }).catch(function () {});
        bumpCartCount();
      })
      .catch(function () { pill.classList.remove('is-busy'); toast(strings.error); });
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('[data-buy-bar-step]');
    if (step) { e.preventDefault(); buyBarStep(step); return; }
    // The name takes the visitor back up to the bag
    var top = e.target.closest && e.target.closest('[data-buy-bar-top]');
    if (top) {
      var target = document.querySelector('.product-form');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    // The weight opens the list of weights above the pill; picking one picks it in the product form too
    var pop = document.querySelector('[data-buy-bar-pop]');
    var wbtn = e.target.closest && e.target.closest('[data-buy-bar-weight-btn]');
    if (wbtn && pop) {
      var open = pop.hidden;
      pop.hidden = !open; wbtn.setAttribute('aria-expanded', String(open));
      return;
    }
    var opt = pop && e.target.closest && e.target.closest('[data-buy-bar-pop] [data-value]');
    if (opt) {
      var input = document.querySelector('.product-form [data-option-input][data-position="1"][value="' + opt.dataset.value.replace(/"/g, '\\"') + '"]')
        || document.querySelector('.product-form select[data-option-input][data-position="1"]');
      if (input && input.tagName === 'SELECT') { input.value = opt.dataset.value; input.dispatchEvent(new Event('change', { bubbles: true })); }
      else if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      pop.querySelectorAll('[data-value]').forEach(function (li) { li.setAttribute('aria-selected', String(li === opt)); });
    }
    if (pop && !pop.hidden && !(e.target.closest && e.target.closest('[data-buy-bar-pop]'))) {
      pop.hidden = true;
      var b = document.querySelector('[data-buy-bar-weight-btn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    if (opt) { pop.hidden = true; var bb = document.querySelector('[data-buy-bar-weight-btn]'); if (bb) bb.setAttribute('aria-expanded', 'false'); }
  });

  // Bring every picks button in line with the cart (items from a cart / cart-change response)
  function syncPicks(items) {
    if (!items) return;
    syncBuyBar(items);
    var pq = {};
    items.forEach(function (it) { pq[it.product_id] = (pq[it.product_id] || 0) + it.quantity; });
    document.querySelectorAll('[data-pick-product]').forEach(function (b) {
      setPickState(b, pq[b.dataset.pickProduct] || 0);
    });
    // Product cards: bags of each coffee and of each variant in the cart
    var qty = {}, vq = {};
    items.forEach(function (it) {
      qty[it.product_id] = (qty[it.product_id] || 0) + it.quantity;
      vq[it.variant_id] = (vq[it.variant_id] || 0) + it.quantity;
    });
    document.querySelectorAll('[data-card]').forEach(function (foot) {
      foot.dataset.cardTotal = qty[foot.dataset.card] || 0;
      foot.querySelectorAll('[data-wt-variant]').forEach(function (w) {
        if (!foot.hasAttribute('data-card-plus')) w.classList.toggle('is-in-cart', !!vq[w.dataset.wtVariant]);
        w.dataset.wtQty = vq[w.dataset.wtVariant] || 0;
      });
      autoPickWeight(foot);
      renderCard(foot);
      fitWeights(foot);
    });
  }
  // A card's picked weight moves on to the first weight not in the cart yet; with every weight in the cart nothing is picked
  function autoPickWeight(foot) {
    // Product cards and picks keep their weight ("+" always adds it)
    if (isPlusCard(foot)) return;
    var single = foot.querySelector('.card__wt.is-single');
    if (single) single.classList.toggle('is-picked', !single.classList.contains('is-in-cart'));
    var ws = Array.prototype.slice.call(foot.querySelectorAll('button.card__wt'));
    if (!ws.length) return;
    var cur = ws.filter(function (w) { return w.getAttribute('aria-pressed') === 'true'; })[0];
    if (cur && !cur.classList.contains('is-in-cart')) return;
    var next = ws.filter(function (w) { return !w.classList.contains('is-in-cart'); })[0];
    if (next) { pickWeight(foot, next); return; }
    ws.forEach(function (w) { w.setAttribute('aria-pressed', 'false'); });
  }
  // At most 3 weights on a card, fewer when they don't fit on one line (the last ones go first;
  // the picked weight and weights already in the cart always stay)
  function fitWeights(foot) {
    var box = foot.querySelector('.card__weights');
    if (!box) return;
    var items = Array.prototype.slice.call(box.querySelectorAll('.card__wt'));
    if (items.length < 2) return;
    items.forEach(function (w) { w.style.display = ''; });
    var keep = function (w) { return w.getAttribute('aria-pressed') === 'true' || w.classList.contains('is-in-cart'); };
    var visible = function () { return items.filter(function (w) { return w.style.display !== 'none'; }); };
    var wraps = function () {
      var v = visible();
      return v.some(function (w) { return Math.abs(w.offsetTop - v[0].offsetTop) > 2; });
    };
    // Drop from the end: first weights that are neither picked nor in the cart, then (if still needed)
    // weights in the cart; the picked weight always stays
    var pass = function (canDrop) {
      var max = parseInt(box.dataset.wtMax, 10) || 3;
    var guard = items.length;
      while (guard-- > 0 && (visible().length > max || wraps())) {
        var v = visible();
        if (v.length < 2) return;
        var drop = null;
        for (var i = v.length - 1; i >= 0; i--) { if (canDrop(v[i])) { drop = v[i]; break; } }
        if (!drop) return;
        drop.style.display = 'none';
      }
    };
    pass(function (w) { return !keep(w); });
    pass(function (w) { return w.getAttribute('aria-pressed') !== 'true'; });
  }
  function fitAllWeights() { document.querySelectorAll('[data-card]').forEach(fitWeights); }
  // Card tasting notes: at most 3 lines; whole notes go from the end until they fit (at least one stays)
  function fitTones(el) {
    var tones = el.querySelectorAll('.card__tone'), seps = el.querySelectorAll('.card__tone-sep');
    if (!tones.length) return;
    tones.forEach(function (t) { t.classList.remove('is-off'); });
    seps.forEach(function (t) { t.classList.remove('is-off'); });
    var lh = parseFloat(getComputedStyle(el).lineHeight) || 20;
    for (var n = tones.length - 1; n > 0 && el.getBoundingClientRect().height > lh * 3 + 2; n--) {
      tones[n].classList.add('is-off');
      if (seps[n - 1]) seps[n - 1].classList.add('is-off');
    }
  }
  function fitAllTones() { document.querySelectorAll('[data-card-tones]').forEach(fitTones); }
  // A card's button follows the picked weight. Product cards and picks: always "+" with a tag counting the picked weight's bags
  function isPlusCard(foot) { return foot.classList.contains('card__foot') || foot.hasAttribute('data-card-plus'); }
  function renderCard(foot) {
    var b = foot.querySelector('.card__add');
    if (!b) return;
    // Product cards and picks: always "+" for the picked bag, with a tag counting that weight's bags in the cart
    // (picks with text, desktop hero: "+ Do košíku", then "+ Přidat" once there is a count)
    if (isPlusCard(foot)) {
      var pick = foot.querySelector('button.card__wt[aria-pressed="true"], .card__wt.is-single');
      var n = pick ? parseInt(pick.dataset.wtQty, 10) || 0 : parseInt(foot.dataset.cardTotal, 10) || 0;
      var c = b.querySelector('[data-card-count]');
      if (c) c.textContent = n > 0 ? n : '';
      b.classList.toggle('has-count', n > 0);
      b.classList.remove('is-added');
      b.removeAttribute('data-cart-drawer-open');
      b.setAttribute('data-quick-add', b.dataset.cardVariant);
      b.setAttribute('aria-label', b.dataset.addAria + (n > 0 ? ' (' + b.dataset.addedAria + ': ' + n + ')' : ''));
      // Product cards: "+ Do košíku" turns into "− n +" for the picked weight; its "+" switches off at the stock limit
      var buy = b.closest('.card__buy');
      if (buy) {
        var had = buy.classList.contains('has-qty');
        buy.classList.toggle('has-qty', n > 0);
        var val = buy.querySelector('[data-card-qty-value]');
        if (val) val.textContent = n;
        var plus = buy.querySelector('[data-card-qty-step="1"]');
        var max = readMax()[b.dataset.cardVariant];
        if (plus) {
          if (max && n >= max) plus.setAttribute('aria-disabled', 'true');
          else plus.removeAttribute('aria-disabled');
        }
        // Keep the focus on what is now shown (the hidden button / pill can't hold it)
        var active = document.activeElement;
        if (!had && n > 0 && active === b && plus) plus.focus();
        if (had && n === 0 && active && buy.contains(active) && active !== b) b.focus();
      }
      return;
    }
    var total = parseInt(foot.dataset.cardTotal, 10) || 0;
    var ws = foot.querySelectorAll('[data-wt-variant]');
    var wt = foot.querySelector('[data-wt-variant="' + b.dataset.cardVariant + '"]');
    var allIn = ws.length > 0 && Array.prototype.every.call(ws, function (w) { return w.classList.contains('is-in-cart'); });
    setCardState(b, (allIn || (wt ? wt.classList.contains('is-in-cart') : total > 0)) ? total : 0);
  }
  // Picking a weight on a card: its price, and "+" / check for that bag
  function initCardWeights() {
    document.addEventListener('click', function (e) {
      var w = e.target.closest && e.target.closest('button.card__wt[data-wt-variant]');
      if (!w) return;
      e.preventDefault();
      var foot = w.closest('[data-card]');
      if (!foot) return;
      pickWeight(foot, w);
      renderCard(foot);
      fitWeights(foot);
    });
    fitAllWeights();
    fitAllTones();
    // Pills already showing (bags in the cart on load): switch "+" off where the stock limit was reached this visit
    document.querySelectorAll('.card__foot--pick').forEach(renderCard);
    var fitTimer;
    window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(function () { fitAllWeights(); fitAllTones(); }, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitAllWeights(); fitAllTones(); });
  }
  // Pick a weight on a card: underline it, show its price and point "+" at that bag
  function pickWeight(foot, w) {
    foot.querySelectorAll('button.card__wt').forEach(function (o) { o.setAttribute('aria-pressed', o === w ? 'true' : 'false'); });
    var price = foot.querySelector('.card__price .price, [data-pick-price] .price');
    if (price && w.dataset.wtPrice) {
      price.innerHTML = '';
      var now = document.createElement('span');
      now.textContent = w.dataset.wtPrice;
      price.appendChild(now);
      if (w.dataset.wtCompare) {
        var was = document.createElement('s');
        was.className = 'price__compare';
        was.textContent = w.dataset.wtCompare;
        price.appendChild(was);
      }
    }
    var b = foot.querySelector('.card__add');
    if (b) b.dataset.cardVariant = w.dataset.wtVariant;
    syncWeightPick(foot);
  }
  // Product card price/weight button and its list follow the picked weight
  function syncWeightPick(foot) {
    var pick = foot.querySelector('.wt-pick');
    if (!pick) return;
    var cur = foot.querySelector('button.card__wt[aria-pressed="true"]');
    if (!cur) return;
    var label = pick.querySelector('[data-wt-label]');
    if (label) label.textContent = cur.textContent.trim();
    var name = (pick.getAttribute('aria-label') || '').split(':')[0];
    pick.setAttribute('aria-label', name + ': ' + cur.textContent.trim());
    foot.querySelectorAll('.wt-pop [data-wt-pick]').forEach(function (li) {
      li.setAttribute('aria-selected', li.dataset.wtPick === cur.dataset.wtVariant ? 'true' : 'false');
    });
  }
  // Product cards: tap on "420 Kč  250 g ▾" opens the list of weights; picking one switches the card.
  // Closes on a pick, a tap elsewhere or Esc; arrow keys move through the list
  function initWeightPop() {
    var open = null;
    var close = function (focus) {
      if (!open) return;
      var btn = open.parentNode.querySelector('.wt-pick');
      open.hidden = true;
      if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focus) btn.focus(); }
      open = null;
    };
    var items = function () { return open ? Array.prototype.slice.call(open.querySelectorAll('[data-wt-pick]')) : []; };
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var btn = t.closest('.wt-pick');
      if (btn) {
        e.preventDefault();
        var list = btn.parentNode.querySelector('.wt-pop');
        if (!list) return;
        if (open === list) { close(); return; }
        close();
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        open = list;
        var sel = list.querySelector('[aria-selected="true"]') || list.querySelector('[data-wt-pick]');
        if (sel && e.detail === 0) sel.focus();
        return;
      }
      var li = t.closest('.wt-pop [data-wt-pick]');
      if (li) {
        e.preventDefault();
        var foot = li.closest('[data-card]');
        var w = foot && foot.querySelector('button.card__wt[data-wt-variant="' + li.dataset.wtPick + '"]');
        if (w) w.click();
        close(true);
        return;
      }
      if (open && !t.closest('.wt-pop')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      var list = items();
      var i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var n = e.key === 'ArrowDown' ? Math.min(list.length - 1, i + 1) : Math.max(0, i - 1);
        if (list[n]) list[n].focus();
      } else if ((e.key === 'Enter' || e.key === ' ') && i >= 0) {
        e.preventDefault();
        list[i].click();
      }
    });
  }
  function setCardState(b, qty) {
    var count = b.querySelector('[data-card-count]');
    if (count) count.textContent = qty > 0 ? qty : '';
    b.classList.toggle('is-added', qty > 0);
    if (qty > 0) {
      b.removeAttribute('data-quick-add');
      b.setAttribute('data-cart-drawer-open', '');
      b.setAttribute('aria-label', b.dataset.addedAria + ': ' + qty);
    } else {
      b.setAttribute('data-quick-add', b.dataset.cardVariant);
      b.removeAttribute('data-cart-drawer-open');
      b.setAttribute('aria-label', b.dataset.addAria);
    }
  }
  // Mark one coffee's lines in the open cart drawer (from a product card): when they are hidden
  // under the sticky header/footer or further down, scroll them into the middle first, then highlight
  // Bags that Shopify refused to add more of (stock or a limit): their "+" stays switched off while the cart holds
  // at least that many (remembered for the visit)
  var MAX_KEY = 'sk-max-qty';
  function readMax() { try { return JSON.parse(sessionStorage.getItem(MAX_KEY) || '{}'); } catch (e) { return {}; } }
  function rememberMax(variantId, qty) {
    var m = readMax(); m[variantId] = qty;
    try { sessionStorage.setItem(MAX_KEY, JSON.stringify(m)); } catch (e) {}
  }
  function applyMax(root) {
    var m = readMax();
    $$('.cart-sub[data-cart-variant]', root).forEach(function (sub) {
      var max = m[sub.dataset.cartVariant];
      var val = $('.qty__value', sub);
      var plus = $('.qty [data-line-change]:last-of-type', sub);
      if (max && val && plus && (parseInt(val.textContent, 10) || 0) >= max) {
        plus.setAttribute('aria-disabled', 'true');
      }
    });
  }
  // Desktop (mouse): the reason shows as a small bubble above the switched-off "+", a moment after the pointer
  // rests on it. It floats, so the cart doesn't move. Touch screens show the same bubble on a tap (below)
  var fineHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var maxTip, maxTipFor, maxTipTimer;
  function showMaxTip(btn) {
    if (!maxTip) {
      maxTip = document.createElement('div');
      maxTip.className = 'max-tip';
      maxTip.id = 'max-tip';
      maxTip.setAttribute('role', 'tooltip');
      document.body.appendChild(maxTip);
    }
    maxTip.textContent = strings.maxInCart || strings.error;
    maxTipFor = btn;
    btn.setAttribute('aria-describedby', 'max-tip');
    var r = btn.getBoundingClientRect();
    maxTip.style.left = '0px';
    maxTip.classList.add('is-visible');
    var w = maxTip.offsetWidth, h = maxTip.offsetHeight;
    var left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8);
    var below = r.top - h - 10 < 8;
    maxTip.classList.toggle('is-below', below);
    maxTip.style.left = left + 'px';
    maxTip.style.top = (below ? r.bottom + 10 : r.top - h - 10) + 'px';
    maxTip.style.setProperty('--arrow-x', (r.left + r.width / 2 - left) + 'px');
  }
  function hideMaxTip() {
    clearTimeout(maxTipTimer);
    if (maxTipFor) maxTipFor.removeAttribute('aria-describedby');
    maxTipFor = null;
    if (maxTip) maxTip.classList.remove('is-visible');
  }
  function isOffPlus(el) {
    return el && el.getAttribute('aria-disabled') === 'true' && el.closest('.qty, .card__qty') ? el : null;
  }
  if (fineHover) {
    document.addEventListener('mouseover', function (e) {
      var btn = isOffPlus(e.target.closest && e.target.closest('button'));
      if (!btn || btn === maxTipFor) return;
      hideMaxTip();
      maxTipTimer = setTimeout(function () { showMaxTip(btn); }, 250);
    });
    document.addEventListener('mouseout', function (e) {
      var btn = isOffPlus(e.target.closest && e.target.closest('button'));
      if (btn && !btn.contains(e.relatedTarget)) hideMaxTip();
    });
    window.addEventListener('scroll', hideMaxTip, true);
  }
  // Clicking or tapping a switched-off "+" shows the same bubble straight away. On touch screens it goes away
  // after a moment or a tap anywhere else (with a mouse, when the pointer leaves the "+")
  function briefMaxNote(trigger) {
    clearTimeout(maxTipTimer);
    showMaxTip(trigger);
    if (!fineHover) maxTipTimer = setTimeout(hideMaxTip, 4000);
  }
  document.addEventListener('pointerdown', function (e) {
    if (maxTipFor && !maxTipFor.contains(e.target)) hideMaxTip();
  }, true);
  function highlightCartLine(productId, variantId, failed, removed) {
    // The whole coffee lights up softly and the weight just added gets a check. When the bag could NOT be added
    // (failed: e.g. no more in stock), the coffee lights up warm instead, its weight gets a red cross, a short note
    // under it and its "+" is switched off until the cart changes. removed: a bag was taken away, the weight gets a dark "−1" instead of the check
    var lines = Array.prototype.slice.call(document.querySelectorAll('[data-cart-drawer] [data-cart-product="' + productId + '"]'));
    if (!lines.length) return;
    var added = variantId ? lines[0].querySelector('.cart-sub[data-cart-variant="' + variantId + '"]') : null;
    if (failed && added) {
      var note = added.querySelector('.cart-sub__note');
      if (!note) { note = document.createElement('p'); note.className = 'cart-sub__note'; note.setAttribute('role', 'alert'); added.appendChild(note); }
      note.textContent = strings.maxInCart || strings.error;
      var plus = added.querySelector('.qty [data-line-change]:last-of-type');
      if (plus) plus.setAttribute('aria-disabled', 'true');
      var val = added.querySelector('.qty__value');
      if (val) rememberMax(variantId, parseInt(val.textContent, 10) || 1);
    }
    var panel = lines[0].closest('.drawer__panel');
    var flash = function (el, cls, ms) {
      el.classList.remove(cls);
      void el.offsetWidth;
      el.classList.add(cls);
      clearTimeout(el['_' + cls]);
      el['_' + cls] = setTimeout(function () { el.classList.remove(cls); }, ms);
    };
    var mark = function () {
      lines.forEach(function (li) { flash(li, failed ? 'is-highlight-error' : 'is-highlight', 3000); });
      if (added) flash(added, failed ? 'is-failed-flash' : removed ? 'is-removed-flash' : 'is-added-flash', 3000);
    };
    if (!panel) { mark(); return; }
    var pr = panel.getBoundingClientRect();
    var top = pr.top, bottom = pr.bottom;
    var head = panel.querySelector('.cart-drawer__header');
    if (head) top = head.getBoundingClientRect().bottom;
    var foot = panel.querySelector('.cart-drawer__footer');
    if (foot && getComputedStyle(foot).position === 'sticky') bottom = Math.min(bottom, foot.getBoundingClientRect().top);
    // The block from the first to the last of those lines
    var first = lines[0].getBoundingClientRect(), last = lines[lines.length - 1].getBoundingClientRect();
    var r = { top: first.top, bottom: last.bottom, height: last.bottom - first.top };
    if (r.top >= top - 1 && r.bottom <= bottom + 1) { mark(); return; }
    // Centre the block; when it is taller than the visible area, start at its first line
    var delta = r.top - top - Math.max(0, (bottom - top - r.height) / 2);
    var done = false;
    var finish = function () { if (done) return; done = true; panel.removeEventListener('scrollend', finish); mark(); };
    panel.addEventListener('scrollend', finish);
    setTimeout(finish, 700);
    panel.scrollBy({ top: delta, behavior: 'smooth' });
  }
  function syncPicksFromCart() {
    // Picks buttons, product cards, or the phones' buy pill on a product page
    if (!document.querySelector('[data-pick-product], [data-card], [data-buy-bar]')) return;
    fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { syncPicks(cart.items); })
      .catch(function () {});
  }

  // Header cart count: a short bump (the card's pill changes the cart without opening it)
  function bumpCartCount() {
    $$('[data-cart-count]').forEach(function (c) {
      c.classList.remove('is-bump');
      void c.offsetWidth;
      c.classList.add('is-bump');
    });
  }
  // Product card pill "− n +": one bag more or less of the picked weight; the cart stays closed
  function cardStep(btn) {
    var buy = btn.closest('.card__buy');
    var foot = btn.closest('[data-card]');
    var add = buy && buy.querySelector('.card__add');
    var box = buy && buy.querySelector('[data-card-qty]');
    if (!foot || !add || !box || box.classList.contains('is-busy')) return;
    var variant = add.dataset.cardVariant;
    var step = parseInt(btn.dataset.cardQtyStep, 10) > 0 ? 1 : -1;
    if (step > 0 && btn.getAttribute('aria-disabled') === 'true') { briefMaxNote(btn); return; }
    var pick = foot.querySelector('[data-wt-variant="' + variant + '"]');
    var n = pick ? parseInt(pick.dataset.wtQty, 10) || 0 : 0;
    box.classList.add('is-busy');
    var url = step > 0 ? routes.cart_add_url : routes.cart_change_url;
    var body = step > 0
      ? { items: [{ id: parseInt(variant, 10), quantity: 1 }] }
      : { id: String(variant), quantity: Math.max(0, n - 1) };
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        box.classList.remove('is-busy');
        if (!r.ok) {
          // No more in stock: "+" switches off for that weight and says why in a bubble
          if (step > 0) {
            rememberMax(variant, n);
            renderCard(foot);
            briefMaxNote(btn);
          } else {
            toast(r.data.description || r.data.message || strings.error);
          }
          return;
        }
        if (cartDrawer()) renderCartDrawer(r.data.sections && r.data.sections[CART_SECTION]);
        if (step > 0) {
          // The answer has only the bag just added: count it here, then bring the other buttons (picks) in line
          if (pick) pick.dataset.wtQty = n + 1;
          foot.dataset.cardTotal = (parseInt(foot.dataset.cardTotal, 10) || 0) + 1;
          renderCard(foot);
          if (!cartDrawer()) fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); }).then(function (c) { setCartCount(c.item_count); }).catch(function () {});
          syncPicksFromCart();
        } else {
          // The answer is the whole cart: every card and picks button follows it
          syncPicks(r.data.items);
          if (!cartDrawer()) setCartCount(r.data.item_count || 0);
        }
        bumpCartCount();
      })
      .catch(function () {
        box.classList.remove('is-busy');
        toast(strings.error);
      });
  }

  // One-tap add from the empty-cart suggestions; the drawer re-renders in place
  function quickAdd(button) {
    var addedVariant = button.dataset.quickAdd;
    var inDrawer = !!button.closest('[data-cart-drawer]');
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.classList.add('is-loading');
    button.disabled = true;
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(button.dataset.quickAdd, 10), quantity: 1 }], sections: CART_SECTION, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || strings.error);
        renderCartDrawer(r.data.sections && r.data.sections[CART_SECTION]);
        // Added from a suggestion inside the open cart (also the empty cart): light up the coffee just added
        // (the button itself is gone by now: the drawer was just re-rendered)
        if (inDrawer) {
          var it = r.data.items && r.data.items[0];
          var inPid = (it && it.product_id) || button.dataset.pickProduct || button.dataset.cardProduct;
          if (inPid) setTimeout(function () { highlightCartLine(inPid, addedVariant); }, 60);
        }
        // Added from the page (e.g. the hero's featured coffee): show the cart
        if (!inDrawer) {
          button.disabled = false;
          // Picks cards: every copy of this coffee's button (hero, desktop card, menu) now reads
          // "✓ In cart" and opens the cart; the carousels move on to a coffee not in the cart yet
          if (button.dataset.pickProduct) {
            document.querySelectorAll('[data-pick-product="' + button.dataset.pickProduct + '"]').forEach(function (b) {
              setPickState(b, (parseInt(b.dataset.pickQty, 10) || 0) + 1);
            });
            // The carousels move on to a coffee not in the cart yet once the cart is closed again (1 s later)
            var pickBox = button.closest('[data-hero-pick]');
            if (pickBox) pickBox.dataset.justAdded = '1';
            if (cartDrawer()) pickAdvancePending = true;
            else setTimeout(function () { advanceHeroPicks(true); }, 500);
            var addedId = button.dataset.pickProduct;
            setTimeout(function () { highlightCartLine(addedId, addedVariant); }, 340);
          }
          syncPicksFromCart();
          // Picks with weights (desktop hero): the carousel moves on once the cart is closed again
          var addedPick = button.closest('[data-hero-pick]');
          if (button.dataset.cardProduct && addedPick) { pickAdvancePending = true; addedPick.dataset.justAdded = '1'; }
          // Product card: highlight the coffee in the cart that is about to open
          if (button.dataset.cardProduct) {
            var pid = button.dataset.cardProduct;
            var foot = button.closest('[data-card]');
            if (foot) {
              foot.dataset.cardTotal = (parseInt(foot.dataset.cardTotal, 10) || 0) + 1;
              var picked = foot.querySelector('[data-wt-variant="' + button.dataset.cardVariant + '"]');
              if (picked) {
                if (!foot.hasAttribute('data-card-plus')) picked.classList.add('is-in-cart');
                picked.dataset.wtQty = (parseInt(picked.dataset.wtQty, 10) || 0) + 1;
              }
              autoPickWeight(foot);
              renderCard(foot);
              fitWeights(foot);
            } else {
              setCardState(button, 1);
            }
            setTimeout(function () { highlightCartLine(pid, addedVariant); }, 340);
          }
          // Added from the menu drawer: close it so the cart can take over
          var menuClose = button.closest('#MenuDrawer') && document.querySelector('#MenuDrawer .drawer__close');
          if (menuClose) menuClose.click();
          openCartDrawer();
        }
      })
      .catch(function (err) {
        var current = $('[data-cart-drawer-inner]');
        if (current) current.classList.remove('is-loading');
        button.disabled = false;
        var box = $('[data-cart-drawer-error]');
        var hl = button.dataset.cardProduct || button.dataset.pickProduct;
        // That bag is already in the cart (e.g. no more in stock): the note goes on its row, not at the top
        var row = hl && addedVariant && document.querySelector('[data-cart-drawer] [data-cart-product="' + hl + '"] .cart-sub[data-cart-variant="' + addedVariant + '"]');
        if (box) box.textContent = row ? '' : (err.message || strings.error);
        // Added from the page: open the cart anyway, so the message and the coffee are in view
        if (!inDrawer) {
          var menuClose = button.closest('#MenuDrawer') && document.querySelector('#MenuDrawer .drawer__close');
          if (menuClose) menuClose.click();
          openCartDrawer();
          if (row) {
            setTimeout(function () { highlightCartLine(hl, addedVariant, true); }, 340);
          } else {
            var drawerEl = cartDrawer();
            var panel = drawerEl && drawerEl.querySelector('.drawer__panel');
            if (panel) panel.scrollTop = 0;
          }
        }
      });
  }

  // Cart page, right after adding a suggestion or changing a quantity: the coffee gets the same soft highlight as in
  // the cart drawer, and the weight a bag was added to gets the check
  var ADDED_KEY = 'sk-cart-added';
  function initCartPageAdded() {
    var raw = null;
    try { raw = sessionStorage.getItem(ADDED_KEY); sessionStorage.removeItem(ADDED_KEY); } catch (e) {}
    // The browser keeps its own scroll restoring off for this one reload; back on when leaving the page
    if ('scrollRestoration' in history && history.scrollRestoration === 'manual') {
      if (!raw) history.scrollRestoration = 'auto';
      else window.addEventListener('pagehide', function () { history.scrollRestoration = 'auto'; });
    }
    if (!raw) return;
    window.scrollTo(0, 0);
    var a; try { a = JSON.parse(raw); } catch (e) { return; }
    if (!a || Date.now() - a.t > 15000) return;
    var rows = $$('.cart-table tr[data-cart-product="' + a.p + '"]');
    if (!rows.length) return;
    var first = rows[0].getBoundingClientRect(), last = rows[rows.length - 1].getBoundingClientRect();
    var head = $('.header'), top = head ? Math.max(0, head.getBoundingClientRect().bottom) : 0;
    if (first.top < top || last.bottom > window.innerHeight) {
      window.scrollBy(0, first.top - top - Math.max(16, (window.innerHeight - top - (last.bottom - first.top)) / 2));
    }
    var added = rows.filter(function (r) { return r.dataset.cartVariant === String(a.v); })[0];
    var mark = a.check ? 'is-added-flash' : 'is-removed-flash';
    setTimeout(function () {
      rows.forEach(function (r) { r.classList.add('is-highlight'); setTimeout(function () { r.classList.remove('is-highlight'); }, 3000); });
      if (added) { added.classList.add(mark); setTimeout(function () { added.classList.remove(mark); }, 3000); }
    }, 250);
  }

  // Cart page suggestions (no drawer there): add one coffee, then reload so totals and discounts update
  function initCartPageOffers() {
    var box = $('[data-cart-page-offers]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var button = e.target.closest && e.target.closest('[data-quick-add]');
      if (!button) return;
      e.preventDefault();
      button.disabled = true;
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(button.dataset.quickAdd, 10), quantity: 1 }] })
      })
        .then(function (res) {
          if (res.ok) {
            // Reload so totals and discounts update. The page starts at the top (where the added coffee shows)
            // instead of jumping back to this button, and the added coffee lights up once loaded
            return res.json().then(function (d) {
              var it = (d.items && d.items[0]) || d;
              try { sessionStorage.setItem(ADDED_KEY, JSON.stringify({ p: it.product_id, v: it.variant_id || it.id, check: true, t: Date.now() })); } catch (e) {}
              if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
              window.location.reload();
            });
          }
          return res.json().then(function (d) { throw new Error(d.description || d.message || strings.error); }, function () { throw new Error(strings.error); });
        })
        .catch(function (err) {
          button.disabled = false;
          // e.g. no more bags in stock: the same notice as in the cart drawer, above the suggestions
          var note = box.querySelector('.cart-drawer__error');
          if (!note) { note = document.createElement('p'); note.className = 'cart-drawer__error'; note.setAttribute('role', 'alert'); box.prepend(note); }
          note.textContent = err.message || strings.error;
        });
    });
  }

  function initCartDrawer() {
    if (!cartDrawer()) return;
    applyMax(cartDrawer());
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var opener = t.closest('[data-cart-drawer-open]');
      if (opener) {
        e.preventDefault();
        openCartDrawer();
        var hlId = opener.dataset.cardProduct || opener.dataset.pickProduct;
        if (hlId) setTimeout(function () { highlightCartLine(hlId); }, 340);
        return;
      }
      if (t.closest('[data-cart-drawer-close]')) { e.preventDefault(); closeCartDrawer(); return; }
      var cardQty = t.closest('[data-card-qty-step]');
      if (cardQty) { e.preventDefault(); cardStep(cardQty); return; }
      var add = t.closest('[data-quick-add]');
      if (add) { e.preventDefault(); quickAdd(add); return; }
      var change = t.closest('[data-line-change]');
      if (change && change.getAttribute('aria-disabled') === 'true') {
        // Switched-off "+": say why in a bubble over it
        e.preventDefault();
        briefMaxNote(change);
        return;
      }
      if (change) {
        e.preventDefault();
        changeCartLine(parseInt(change.dataset.line, 10), Math.max(0, parseInt(change.dataset.quantity, 10) || 0), change);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty(ctx) {
    $$('.qty', ctx).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = $('input', wrap);
      $$('[data-qty]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Cart page "+" switched off (all in stock already in the cart): say why in a bubble over it
          if (btn.getAttribute('aria-disabled') === 'true') {
            briefMaxNote(btn);
            return;
          }
          var min = parseInt(input.min || '0', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qty, 10));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Auto-submit (sorting, cart quantities) ---------- */
  function initAutosubmit() {
    var timer;
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el.matches || !el.matches('[data-autosubmit]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (el.form) {
          if (el.form.id === 'CartForm') {
            // After the page reloads, the changed coffee lights up (a check when a bag was added, "−1" when one was taken)
            var row = el.closest('tr[data-cart-product]');
            var now = parseInt(el.value, 10) || 0, before = parseInt(el.defaultValue, 10) || 0;
            if (row && now > 0 && now !== before) {
              try { sessionStorage.setItem(ADDED_KEY, JSON.stringify({ p: row.dataset.cartProduct, v: row.dataset.cartVariant, check: now > before, t: Date.now() })); } catch (e) {}
            }
            var hidden = document.createElement('input');
            hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
            el.form.appendChild(hidden);
          }
          el.form.submit();
        }
      }, 400);
    });

    // Filter checkboxes apply immediately
    var filterForm = $('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('change', function (e) {
        if (e.target.type === 'checkbox') filterForm.submit();
      });
      filterForm.addEventListener('submit', function () {
        // Drop empty price inputs so they don't end up in the URL
        $$('input[type="number"]', filterForm).forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    }
  }

  /* ---------- Product: variants, gallery, AJAX add ---------- */
  function initProduct(root) {
    var form = $('[data-product-form]', root);
    var variantsEl = $('[data-variants]', root);
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (e) { variants = []; }

    var idInput = form ? $('[data-variant-id]', form) : null;
    var addBtn = form ? $('[data-add-button]', form) : null;
    // "Add to cart" also says what the chosen bags cost together
    var qtyField = form ? $('.product-form__buy .qty input', form) : null;
    var curVariant = null;
    function updateAddLabel() {
      if (!addBtn || addBtn.disabled || !curVariant || !curVariant.available) return;
      var q = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);
      var part = function (cls, text) { var e = document.createElement('span'); e.className = cls; e.textContent = text; return e; };
      addBtn.textContent = '';
      addBtn.appendChild(part('add-label add-label--long', strings.addToCart));
      addBtn.appendChild(part('add-label add-label--short', addBtn.dataset.short || strings.addToCart));
      var sep = part('add-sep', ' · '); sep.setAttribute('aria-hidden', 'true'); addBtn.appendChild(sep);
      addBtn.appendChild(part('add-total', formatMoney(curVariant.price * q)));
    }
    if (qtyField) { qtyField.addEventListener('change', updateAddLabel); qtyField.addEventListener('input', updateAddLabel); }
    // Phones: a bar at the bottom with the price and "Add to cart" once the real button has scrolled up out of view
    var buyBar = root.parentNode ? $('[data-buy-bar]', root.parentNode) : null;
    if (buyBar && addBtn && 'IntersectionObserver' in window) {
      var barBtn = $('[data-buy-bar-button]', buyBar);
      if (barBtn) barBtn.addEventListener('click', function () { addBtn.click(); });
      // Keep clear of the chat button (or any other app button floating at the bottom): look through the app elements
      // appended to <body>, including their shadow DOM (Shopify Inbox draws its button there), for anything visible in
      // the bottom band of the screen, and fit the pill into the space beside it. Found nothing (the chat not loaded
      // yet, or drawn somewhere we can't see): keep the default 9.2rem free on the right (base.css)
      var fitBarToChat = function () {
        var vw = document.documentElement.clientWidth, vh = window.innerHeight, gap = 10, edge = 12;
        var left = edge, right = vw - edge, found = false, chatLeft = false, seen = 0;
        var check = function (n) {
          if (seen++ > 400 || n === buyBar || buyBar.contains(n)) return;
          var r = n.getBoundingClientRect();
          if (r.width && r.height && r.width < vw * 0.6 && r.top > vh - 170 && r.bottom < vh + 4) {
            var s = getComputedStyle(n);
            if (s.visibility !== 'hidden' && s.display !== 'none' && parseFloat(s.opacity) !== 0) {
              found = true;
              if (r.left + r.width / 2 > vw / 2) right = Math.min(right, r.left - gap);
              else { left = Math.max(left, r.right + gap); chatLeft = true; }
            }
          }
          if (n.shadowRoot) Array.prototype.forEach.call(n.shadowRoot.children, walk);
        };
        var walk = function (n) {
          if (!n || n.nodeType !== 1 || /^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(n.tagName)) return;
          check(n);
          Array.prototype.forEach.call(n.children, walk);
        };
        Array.prototype.forEach.call(document.body.children, function (el) {
          if (!el.matches(THEME_BODY_CHILDREN)) walk(el);
        });
        // The pill sits right beside the chat button and grows away from it with its content
        var st = buyBar.style;
        if (found && right - left > 160) {
          if (chatLeft && right === vw - edge) {
            st.setProperty('--buy-bar-left', left + 'px'); st.setProperty('--buy-bar-right', 'auto');
          } else {
            st.setProperty('--buy-bar-right', (vw - right) + 'px'); st.setProperty('--buy-bar-left', 'auto');
          }
          st.setProperty('--buy-bar-max', (right - left) + 'px');
          buyBar.classList.toggle('is-chat-left', chatLeft && right === vw - edge);
        } else {
          st.removeProperty('--buy-bar-left'); st.removeProperty('--buy-bar-right'); st.removeProperty('--buy-bar-max');
          buyBar.classList.remove('is-chat-left');
        }
      };
      // Shown once the real button has scrolled up out of view, and hidden again at the footer (so it never covers its links)
      var pastButton = false, atFooter = false;
      var updateBar = function () {
        var show = pastButton && !atFooter;
        if (show) fitBarToChat();
        buyBar.classList.toggle('is-shown', show);
        buyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', buyBar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
        if (barBtn) { barBtn.disabled = addBtn.disabled; if (addBtn.disabled) barBtn.textContent = addBtn.textContent; }
        renderBuyBar();
        if (!show) { var bp = $('[data-buy-bar-pop]', buyBar); if (bp) bp.hidden = true; }
      };
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
        updateBar();
      }).observe(addBtn);
      var footer = document.querySelector('.footer, footer, [id*="footer"]');
      if (footer) new IntersectionObserver(function (entries) { atFooter = entries[0].isIntersecting; updateBar(); }).observe(footer);
      window.addEventListener('resize', function () { if (buyBar.classList.contains('is-shown')) fitBarToChat(); });
      if ('MutationObserver' in window) new MutationObserver(function () { if (buyBar.classList.contains('is-shown')) fitBarToChat(); }).observe(document.body, { childList: true });
      syncPicksFromCart();
    }
    var errorEl = form ? $('[data-form-error]', form) : null;
    var limitsEl = $('[data-cart-limits]', root);
    var limits = {};
    try { limits = JSON.parse(limitsEl ? limitsEl.textContent : '{}') || {}; } catch (e) { limits = {}; }
    var unitPricesEl = $('[data-unit-prices]', root);
    var unitPrices = {};
    try { unitPrices = JSON.parse(unitPricesEl ? unitPricesEl.textContent : '{}') || {}; } catch (e) { unitPrices = {}; }
    var buy = form ? $('.product-form__buy', form) : null;
    var maxNote = null;
    if (buy) {
      maxNote = document.createElement('p');
      maxNote.className = 'form-message form-message--error product-form__max';
      maxNote.setAttribute('role', 'status');
      maxNote.hidden = true;
      maxNote.textContent = strings.maxInCart || '';
      buy.insertAdjacentElement('afterend', maxNote);
    }
    // The cart already holds all of this bag that can be bought (stock, or Shopify refused more earlier):
    // "Add to cart", the quantity and the express checkout buttons are switched off, with a note
    function applyLimit(variantId, available) {
      if (!form || !variantId) return;
      var l = limits[variantId] || { inCart: 0, max: null };
      var refused = readMax()[variantId];
      var maxed = available !== false && ((l.max !== null && l.max !== undefined && l.inCart >= l.max) || (refused && l.inCart >= refused));
      if (maxNote) maxNote.hidden = !maxed;
      if (addBtn && maxed) addBtn.disabled = true;
      $$('.product-form__buy .qty button, .product-form__buy .qty input', form).forEach(function (el) { el.disabled = !!maxed; });
      var pay = $('.shopify-payment-button', form);
      if (pay) pay.hidden = !!maxed;
      var qtyIn = $('.product-form__buy .qty input', form);
      if (qtyIn) {
        if (!maxed && l.max !== null && l.max !== undefined) qtyIn.max = Math.max(1, l.max - l.inCart);
        else qtyIn.removeAttribute('max');
      }
    }
    var main = $('[data-gallery-main]', root);

    function showMedia(mediaId) {
      var thumb = $('[data-thumb][data-media-id="' + mediaId + '"]', root);
      if (thumb) thumb.click();
    }

    $$('[data-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = main && $('img', main);
        if (img) {
          img.removeAttribute('srcset');
          img.src = thumb.dataset.src;
          img.setAttribute('srcset', thumb.dataset.srcset);
          var thumbImg = $('img', thumb);
          img.alt = thumbImg ? thumbImg.alt : '';
        }
        $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
      });
    });

    function selectedOptions() {
      var opts = [];
      // Radio buttons (bag size) and drop-down menus (grind) both carry data-option-input
      $$('[data-option-input]', root).forEach(function (input) {
        if (input.tagName === 'SELECT' || input.checked) opts[parseInt(input.dataset.position, 10) - 1] = input.value;
      });
      return opts;
    }

    function updateAvailability(current) {
      // Mark values that would lead to unavailable variants, given other selections
      var selected = selectedOptions();
      $$('[data-option-input]', root).forEach(function (input) {
        if (input.tagName === 'SELECT') return;
        var pos = parseInt(input.dataset.position, 10) - 1;
        var test = selected.slice();
        test[pos] = input.value;
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return test[i] === undefined || o === test[i]; });
        });
        input.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    function onVariantChange() {
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });

      updateAvailability(variant);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? strings.addToCart : strings.soldOut;
      }
      curVariant = variant; updateAddLabel();
      applyLimit(variant.id, variant.available);

      var priceEl = $('[data-price-wrapper] [data-price]', root);
      if (priceEl) {
        var html = '<span>' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
        var barPrice = buyBar && $('[data-buy-bar-price]', buyBar);
        if (barPrice) barPrice.textContent = formatMoney(variant.price);
        if (buyBar) {
          buyBar.dataset.variant = variant.id;
          var barWeight = $('[data-buy-bar-weight]', buyBar);
          if (barWeight) barWeight.textContent = variant.option1;
          $$('[data-buy-bar-pop] [data-value]', buyBar).forEach(function (li) { li.setAttribute('aria-selected', String(li.dataset.value === variant.option1)); });
          renderBuyBar();
        }
      }
      // Per-kg price of the picked bag (the span is added when the first bag shown had none)
      var unitEl = $('[data-price-wrapper] [data-unit-price]', root);
      var unitText = unitPrices[variant.id];
      if (!unitEl && unitText) {
        var wrap = $('[data-price-wrapper]', root);
        if (wrap) {
          unitEl = document.createElement('span');
          unitEl.className = 'unit-price';
          unitEl.setAttribute('data-unit-price', '');
          wrap.appendChild(unitEl);
        }
      }
      if (unitEl) {
        if (unitText) unitEl.innerHTML = unitText;
        unitEl.hidden = !unitText;
      }

      var weightEl = $('[data-weight]', root);
      if (weightEl) weightEl.textContent = variant.title;
      var weightInfo = $('[data-weight-info]', root);
      if (weightInfo) weightInfo.textContent = variant.options[parseInt(weightInfo.dataset.optionIndex, 10) || 0] || variant.title;

      var skuEl = $('[data-sku]', root);
      if (skuEl && skuEl.dataset.fromMetafield !== '1' && variant.sku) skuEl.textContent = variant.sku;

      if (variant.featured_media) showMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('[data-option-input]', root).forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });
    if (variants.length) updateAvailability();
    if (idInput && addBtn && !addBtn.disabled) applyLimit(idInput.value, true);
    if (idInput) { curVariant = variants.find(function (v) { return String(v.id) === String(idInput.value); }) || null; updateAddLabel(); }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (errorEl) errorEl.textContent = '';
        if (addBtn) addBtn.setAttribute('aria-busy', 'true');

        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: (function () {
            var fd = new FormData(form);
            if (cartDrawer()) { fd.append('sections', CART_SECTION); fd.append('sections_url', window.location.pathname); }
            return fd;
          })()
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (!r.ok) throw new Error(r.data.description || r.data.message || strings.error);
            if (idInput) {
              var lid = idInput.value, qIn = $('.product-form__buy .qty input', form);
              limits[lid] = limits[lid] || { inCart: 0, max: null };
              limits[lid].inCart += parseInt(qIn ? qIn.value : 1, 10) || 1;
              applyLimit(lid, true);
            }
            if (cartDrawer() && r.data.sections && r.data.sections[CART_SECTION]) {
              renderCartDrawer(r.data.sections[CART_SECTION]);
              openCartDrawer();
              syncPicksFromCart();
              // Light up the coffee just added, as from the product cards and picks
              var added = r.data.items ? r.data.items[0] : r.data;
              if (added && added.product_id) setTimeout(function () { highlightCartLine(added.product_id, added.variant_id || added.id); }, 340);
              return null;
            }
            return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            if (!cart) return;
            setCartCount(cart.item_count);
            toast(
              '<span>' + strings.added + '</span><a href="' + routes.cart_url + '">' +
                strings.viewCart + ' <svg class="icon icon-arrow" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h16M14 6l6 6-6 6"/></svg></a>'
            );
          })
          .catch(function (err) {
            // Refused (e.g. no more in stock): the same switched-off state and note as when we know it up front
            var vid = idInput && idInput.value;
            if (vid && maxNote) {
              var l = limits[vid] || { inCart: 0, max: null };
              rememberMax(vid, Math.max(1, l.inCart));
              applyLimit(vid, true);
              if (errorEl) errorEl.textContent = '';
              return;
            }
            if (errorEl) errorEl.textContent = err.message || strings.error;
          })
          .finally(function () {
            if (addBtn) addBtn.removeAttribute('aria-busy');
          });
      });
    }
  }

  /* ---------- Promo code copy ---------- */
  function initCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-copy]');
      if (!btn) return;
      var code = btn.dataset.copy;
      var done = function () { toast('<span>' + (btn.dataset.copiedLabel || 'OK') + ': ' + code + '</span>'); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
      else done();
    });
  }

  /* ---------- Customer login: recover password toggle ---------- */
  function initLogin() {
    var recover = $('#RecoverPassword');
    var login = $('#CustomerLogin');
    if (!recover || !login) return;
    function show(isRecover) { recover.hidden = !isRecover; login.hidden = isRecover; }
    $$('[data-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(recover.hidden); });
    });
    if (window.location.hash === '#recover' || $('[data-recover-success]', recover) || $('.form-message--error', recover)) show(true);
  }

  /* ---------- Addresses: default country + delete confirm ---------- */
  function initAddresses() {
    $$('select[data-default]').forEach(function (sel) {
      var val = sel.dataset.default;
      if (val) sel.value = val;
    });
    $$('form[data-confirm]').forEach(function (f) {
      f.addEventListener('submit', function (e) { if (!window.confirm(f.dataset.confirm)) e.preventDefault(); });
    });
  }

  /* ---------- Brew guide: tabs + dose calculator ---------- */
  function initBrew(ctx) {
    $$('[data-brew]', ctx).forEach(function (brew) {
      if (brew.dataset.bound) return;
      brew.dataset.bound = '1';
      var tabs = $$('[data-brew-tab]', brew);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (next === null) return;
          e.preventDefault();
          select(tabs[(next + tabs.length) % tabs.length], true);
        });
      });

      $$('[data-brew-calc]', brew).forEach(function (calc) {
        var cup = parseFloat(calc.dataset.cup) || 0;
        var ratio = parseFloat(calc.dataset.ratio) || 0;
        var cups = parseInt(calc.dataset.cups, 10) || 2;
        function word(n) { return n === 1 ? calc.dataset.one : (n >= 2 && n <= 4 ? calc.dataset.few : calc.dataset.many); }
        // The coffee and water in the recipe above change with the cups (one recipe, no second box with the same numbers)
        var panel = calc.closest('.brew__panel') || calc;
        // The grams in the steps ("Nasypte 12 g kávy…") follow too, scaled from the recipe's own amount
        var base = cups;
        var steps = $$('.brew__steps li', panel);
        steps.forEach(function (li) { li.dataset.text = li.textContent; });
        function render() {
          var water = Math.round(cup * cups);
          $('[data-brew-cups]', calc).textContent = cups + ' ' + word(cups);
          $('[data-brew-water]', panel).textContent = water + ' g';
          $('[data-brew-coffee]', panel).textContent = Math.round(water / ratio) + ' g';
          steps.forEach(function (li) {
            li.textContent = li.dataset.text.replace(/(\d+)(\s?g\b)/g, function (m, n, unit) { return Math.round(n * cups / base) + unit; });
          });
        }
        $$('[data-brew-step]', calc).forEach(function (b) {
          b.addEventListener('click', function () {
            cups = Math.min(12, Math.max(1, cups + parseInt(b.dataset.brewStep, 10)));
            render();
          });
        });
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = $$('.reveal');
    if (!('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ---------- Card score: beside the origin, or on its own line when they don't fit ---------- */
  function fitScore(meta) {
    var o = $('.card__origin', meta), s = $('.card__score', meta);
    meta.classList.remove('is-stacked');
    var fits = o.scrollWidth <= o.clientWidth + 1 && s.getBoundingClientRect().top < o.getBoundingClientRect().bottom;
    if (!fits) meta.classList.add('is-stacked');
  }
  var scoreObserver = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { fitScore(e.target); });
  }) : null;
  function initCardScores(ctx) {
    var metas = $$('.card__meta', ctx).filter(function (m) { return $('.card__score', m) && $('.card__origin', m); });
    metas.forEach(function (m) { fitScore(m); if (scoreObserver) scoreObserver.observe(m); });
    if (!scoreObserver && !ctx) window.addEventListener('resize', function () { $$('.card__meta').forEach(fitScore); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { metas.forEach(fitScore); });
  }

  function init() {
    initHeader();
    initLangMenu();
    initHeroPick();
    initQty();
    initCardWeights();
    initWeightPop();
    initCardScores();
    initCartDrawer();
    initCartPageOffers();
    initCartPageAdded();
    initAutosubmit();
    $$('[data-product]').forEach(initProduct);
    initCopy();
    initLogin();
    initAddresses();
    initBrew();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-init sections when they reload
  document.addEventListener('shopify:section:load', function (e) {
    initQty(e.target);
    initBrew(e.target);
    initCardScores(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
    $$('.reveal', e.target).forEach(function (i) { i.classList.add('is-visible'); });
  });
})();

/* Coffee term hints: "?" opens a short explanation; one at a time, closes on a tap elsewhere or Escape, and is
   nudged sideways so it never runs off the screen (the arrow keeps pointing at the "?") */
(function () {
  // The brewing guide adds its hints (who the expert is) later, from its recipes
  if (!document.querySelector('[data-hint], [data-presets]')) return;
  var closeAll = function () {
    document.querySelectorAll('[data-hint] .hint__bubble:not([hidden])').forEach(function (b) {
      b.hidden = true;
      b.parentNode.querySelector('.hint__btn').setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.hero.is-hint-open').forEach(function (h) { h.classList.remove('is-hint-open'); });
  };
  var open = function (btn) {
    closeAll();
    var bubble = btn.parentNode.querySelector('.hint__bubble');
    // A small × in the corner, so it's clear the bubble can be closed (a tap elsewhere or Escape still work)
    if (!bubble.querySelector('.hint__close')) {
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'hint__close';
      x.setAttribute('aria-label', /^cs/.test(document.documentElement.lang) ? 'Zavřít' : 'Close');
      x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      bubble.insertBefore(x, bubble.firstChild);
    }
    bubble.style.setProperty('--shift', '0px');
    bubble.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    // The hero clips its overflow; while a hint in it is open it lets the bubble hang below (base.css)
    var hero = btn.closest('.hero');
    if (hero) hero.classList.add('is-hint-open');
    // The page's own width, not window.innerWidth: on phones a bubble that sticks out widens the visual viewport
    // (the browser zooms the page out), and measuring against that would leave it sticking out
    var vw = Math.min(document.documentElement.clientWidth, window.innerWidth);
    // Measured while invisible, so a bubble that would stick out is never painted (or zoomed to) in its first position
    bubble.style.visibility = 'hidden';
    var r = bubble.getBoundingClientRect(), m = 16, dx = 0;
    if (r.left < m) dx = m - r.left;
    if (r.right > vw - m) dx = vw - m - r.right;
    bubble.style.setProperty('--shift', dx + 'px');
    bubble.style.visibility = '';
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('.hint__close')) { var hb = e.target.closest('[data-hint]').querySelector('.hint__btn'); closeAll(); if (hb) hb.focus(); return; }
    var btn = e.target.closest('.hint__btn');
    // Taste profile (acidity, body, sweetness, roast): tapping the dots opens the same hint as the term above them
    if (!btn && !e.target.closest('.hint__bubble')) {
      var col = e.target.closest('.label__profile > div');
      if (col) btn = col.querySelector('.hint__btn');
    }
    if (btn) {
      e.preventDefault();
      if (btn.getAttribute('aria-expanded') === 'true') closeAll(); else open(btn);
    } else if (!e.target.closest('.hint__bubble')) {
      closeAll();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  // Map hint: one button zooms from the world map into the country/region and back. The zoom origin is the country's
  // pin on the world map, so the world grows into the country and the country map grows out of the same point
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-map-zoom-toggle]');
    if (!btn) return;
    var box = btn.closest('[data-map-zoom]');
    var stage = box.querySelector('.origin-map__stage');
    var pin = box.querySelector('.origin-map__panel--world .origin-map__dot');
    if (pin && stage) {
      var s = stage.getBoundingClientRect(), p = pin.getBoundingClientRect();
      stage.style.setProperty('--zx', (p.left + p.width / 2 - s.left) + 'px');
      stage.style.setProperty('--zy', (p.top + p.height / 2 - s.top) + 'px');
    }
    var on = !box.classList.contains('is-zoomed');
    box.classList.toggle('is-zoomed', on);
    btn.setAttribute('aria-pressed', String(on));
    var label = btn.querySelector('[data-map-zoom-label]');
    if (label) label.textContent = on ? btn.getAttribute('data-label-out') : btn.getAttribute('data-label-in');
  });
})();

/* Folded steps (long methods): shared by the card renderer and the timer */
var FOLD_AT = 3, FOLD_SHOW = 1;
function foldLabel(card) {
  var fb = card.querySelector('[data-fold-toggle]'), ol = card.querySelector('[data-v="steps"]');
  if (!fb || !ol) return;
  var open = ol.classList.contains('is-open'), n = ol.querySelectorAll('li.brew-step.is-folded').length;
  // "6 dalších kroků" (Czech plural: 1 / 2–4 / 5+), and when the folded part ends ("až do 3:00")
  var forms = (card.dataset.stepsMore || '').split('|'), form = n === 1 ? forms[0] : (n >= 2 && n <= 4 ? forms[1] : forms[2]);
  var times = ol.querySelectorAll('li.brew-step .brew-page__step-time'), end = '';
  Array.prototype.forEach.call(times, function (t) { if (t.textContent) end = t.textContent; });
  fb.setAttribute('aria-expanded', String(open));
  fb.querySelector('[data-fold-label]').textContent = open ? (card.dataset.stepsLess || '') : String(form || '').replace('%s', n);
  var g = fb.querySelector('[data-fold-ghost]'); if (g) g.textContent = '+' + n;
  var sub = fb.querySelector('[data-fold-sub]'); if (sub) { sub.textContent = !open && end ? (card.dataset.stepsUntil || '').replace('%s', end) : ''; sub.hidden = !sub.textContent; }
  // Hide the button once every step is out anyway (the timer has revealed them all)
  fb.hidden = !ol.classList.contains('is-foldable') || (!open && !n);
}
// Unfold steps up to (and including) the i-th one, with a short slide-in for each newly shown step
function foldReveal(card, upTo) {
  var ol = card && card.querySelector('[data-v="steps"].is-foldable');
  if (!ol) return;
  Array.prototype.forEach.call(card.querySelectorAll('li.brew-step.is-folded'), function (li) {
    if (+li.dataset.i <= upTo) { li.classList.remove('is-folded'); if (!ol.classList.contains('is-open')) li.classList.add('is-unfolding'); setTimeout(function () { li.classList.remove('is-unfolding'); }, 700); }
  });
  foldLabel(card);
}
// Long methods while the timer runs: the steps already done fold into one ticked row at the top ("Hotové kroky (3)"),
// so the list above the timer box doesn't keep growing; a click on the row shows them again
function foldDone(card, upTo, brewing) {
  var ol = card && card.querySelector('[data-v="steps"]');
  if (!ol) return;
  var n = 0;
  // A new step under way: the done row folds shut again (it only stays open until the next step)
  if (ol._upTo !== upTo) { ol.classList.remove('is-done-open'); ol._upTo = upTo; }
  Array.prototype.forEach.call(ol.querySelectorAll('li.brew-step'), function (li) {
    var gone = upTo > 0 && +li.dataset.i < upTo && !li.closest('.brew-live__now'); li.classList.toggle('is-gone', gone); if (gone) n++;
  });
  // While the timer runs the preparation (all ticked off by then) joins the same row, so there is one "done" row only
  var prep = card.querySelector('[data-v="prep"]'), nPrep = brewing && prep ? prep.querySelectorAll('li.brew-step').length : 0;
  card.classList.toggle('is-merged', !!nPrep);
  doneRow(card, ol, n + nPrep);
}
// "Než pustíte časovač": once every step there is ticked off (by hand, or by starting the timer), they fold into the
// same ticked row; untick one (after opening the row) and the list is back
function foldPrep(card) {
  var ol = card && card.querySelector('[data-v="prep"]');
  if (!ol) return;
  var lis = ol.querySelectorAll('li.brew-step'), all = lis.length > 0;
  Array.prototype.forEach.call(lis, function (li) { if (!li.classList.contains('is-checked')) all = false; });
  Array.prototype.forEach.call(lis, function (li) { li.classList.toggle('is-gone', all); });
  doneRow(card, ol, all ? lis.length : 0);
}
// The ticked "Hotové kroky (3)" row at the top of a list; a click on it shows the steps again
function doneRow(card, ol, n) {
  var row = ol.querySelector(':scope > li.brew-done-sum');
  if (!n) { if (row) row.hidden = true; ol.classList.remove('is-done-open'); return; }
  if (!row) {
    row = document.createElement('li'); row.className = 'brew-done-sum';
    row.innerHTML = '<button type="button" class="brew-done-sum__btn" aria-expanded="false"><span class="brew-done-sum__tick" aria-hidden="true"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.5l5 5 10-11"/></svg></span><span class="brew-done-sum__label"></span><svg class="brew-fold__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>';
    ol.insertBefore(row, ol.firstChild);
  }
  row.hidden = false;
  row.querySelector('.brew-done-sum__label').textContent = (card.dataset.stepsDoneN || '').replace('%s', n);
  row.querySelector('button').setAttribute('aria-expanded', String(ol.classList.contains('is-done-open')));
}
document.addEventListener('click', function (e) {
  var sb = e.target.closest('.brew-done-sum__btn');
  if (sb) { var sol = sb.closest('ol'); sol.classList.toggle('is-done-open'); sb.setAttribute('aria-expanded', String(sol.classList.contains('is-done-open'))); return; }
  var fb = e.target.closest('[data-fold-toggle]'); if (!fb) return;
  var card = fb.closest('[data-brew]') || fb.parentNode, ol = fb.parentNode.querySelector('[data-v="steps"]');
  if (!ol) return;
  ol.classList.toggle('is-open');
  // Opening: the folded steps slide in rather than jump
  if (ol.classList.contains('is-open')) Array.prototype.forEach.call(ol.querySelectorAll('li.brew-step.is-folded'), function (li) { li.classList.add('is-unfolding'); setTimeout(function () { li.classList.remove('is-unfolding'); }, 700); });
  foldLabel(fb.closest('[data-step-done]') || card);
});

/* Expert's name on a brew card: with a mouse, hovering (or focusing) the name opens the hint and leaving closes it; a
   click doesn't toggle it shut again. Touch screens keep the tap */
(function () {
  var hover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)');
  var on = function () { return hover && hover.matches; };
  var btnOf = function (el) { return el && el.closest && el.closest('.brew-about__hint .hint__btn'); };
  var show = function (btn) { if (btn.getAttribute('aria-expanded') !== 'true') btn.click(); };
  var hide = function (btn) { if (btn.getAttribute('aria-expanded') === 'true') btn.click(); };
  document.addEventListener('mouseover', function (e) { var b = btnOf(e.target); if (b && on()) show(b); });
  document.addEventListener('mouseout', function (e) {
    var h = e.target.closest && e.target.closest('.brew-about__hint'); if (!h || !on()) return;
    if (e.relatedTarget && h.contains(e.relatedTarget)) return;
    hide(h.querySelector('.hint__btn'));
  });
  document.addEventListener('focusin', function (e) { var b = btnOf(e.target); if (b && on()) show(b); });
  document.addEventListener('focusout', function (e) { var b = btnOf(e.target); if (b && on()) hide(b); });
  document.addEventListener('click', function (e) { if (e.isTrusted && on() && btnOf(e.target)) { e.preventDefault(); e.stopPropagation(); } }, true);
})();

/* Lamp toggle (dark mode): the head script sets data-theme before paint; here the lamp flips and remembers it */
(function () {
  var root = document.documentElement;
  if (!document.querySelector('[data-theme-toggle]')) return;
  var sync = function () {
    var on = root.getAttribute('data-theme') === 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('sk-theme', next); } catch (err) {}
    sync();
  });
  // No choice of their own yet: keep following the system when it switches (e.g. automatic dark mode at sunset)
  var mq = window.matchMedia && matchMedia('(prefers-color-scheme: dark)');
  if (mq) {
    var follow = function (e) {
      var own = null; try { own = localStorage.getItem('sk-theme'); } catch (err) {}
      if (own === 'dark' || own === 'light') return;
      root.setAttribute('data-theme', e.matches ? 'dark' : 'light'); sync();
    };
    if (mq.addEventListener) mq.addEventListener('change', follow); else if (mq.addListener) mq.addListener(follow);
  }
  sync();
})();

/* Accordions (Parametry kávy, Doporučená příprava…): a click anywhere on the bar opens one, but an open one closes only
   from its × on the right, so tapping the title while reading doesn't fold it away. Keyboard (Enter/Space) still toggles */
document.addEventListener('click', function (e) {
  var summary = e.target.closest('.accordion summary');
  if (!summary || !summary.parentNode.open || e.detail === 0) return;
  var r = summary.getBoundingClientRect();
  if (e.clientX < r.right - 56) e.preventDefault();
});

/* Stars by the coffee's name and the recipe line under the add button: open the reviews / brewing tab and scroll to it */
document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href="#reviews"], a[href="#brew"]');
  var tab = link && document.getElementById(link.getAttribute('href').slice(1));
  if (!tab) return;
  e.preventDefault();
  var details = tab.querySelector('details');
  if (details) details.open = true;
  tab.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* Coffee details: a farm or altitude too long for its line ends in "…"; only then does it get the dashed underline and
   open its hint with the full text (checked again when the tab opens and on resize) */
(function () {
  if (!document.querySelector('.hint--overflow')) return;
  var check = function () {
    document.querySelectorAll('.hint--overflow').forEach(function (h) {
      var term = h.querySelector('.hint__term');
      var cut = term.scrollWidth > term.clientWidth + 1;
      h.classList.toggle('is-truncated', cut);
      h.querySelector('.hint__btn').tabIndex = cut ? 0 : -1;
    });
  };
  check();
  document.addEventListener('toggle', check, true);
  window.addEventListener('resize', check);
})();

/* Bag-size menu (three and more sizes): the pill opens a list of the sizes with their prices; picking one checks the
   matching radio input, so price and variant follow as with the buttons. One open at a time; closes on a pick, a tap
   elsewhere or Escape; arrow keys move through the list */
(function () {
  if (!document.querySelector('[data-size-menu]')) return;
  var open = null;
  var items = function (menu) { return [].slice.call(menu.querySelectorAll('[data-size-index]')); };
  var close = function (focusBtn) {
    if (!open) return;
    var btn = open.querySelector('.size-menu__btn');
    open.querySelector('.size-menu__pop').hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) btn.focus();
    open = null;
  };
  var sync = function (menu) {
    var inputs = menu.querySelectorAll('input');
    items(menu).forEach(function (li, k) {
      var input = inputs[k];
      li.setAttribute('aria-selected', input.checked ? 'true' : 'false');
      li.classList.toggle('is-soldout', input.classList.contains('is-unavailable'));
      if (input.checked) {
        menu.querySelector('[data-size-label]').textContent = input.value;
        var btn = menu.querySelector('.size-menu__btn');
        btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/:.*$/, ': ' + input.value));
      }
    });
  };
  var pick = function (menu, li) {
    var input = menu.querySelectorAll('input')[parseInt(li.dataset.sizeIndex, 10)];
    if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    sync(menu);
    close(true);
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.size-menu__btn');
    if (btn) {
      var menu = btn.closest('[data-size-menu]');
      if (open === menu) { close(); return; }
      close();
      sync(menu);
      menu.querySelector('.size-menu__pop').hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      open = menu;
      var sel = menu.querySelector('[aria-selected="true"]') || items(menu)[0];
      if (sel) sel.focus({ preventScroll: true });
      return;
    }
    var li = e.target.closest('.size-menu__pop [data-size-index]');
    if (li) { pick(li.closest('[data-size-menu]'), li); return; }
    if (open && !e.target.closest('.size-menu__pop')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') { close(true); return; }
    var list = items(open), i = list.indexOf(document.activeElement);
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var next = list[Math.max(0, Math.min(list.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)))];
      if (next) next.focus();
    } else if ((e.key === 'Enter' || e.key === ' ') && i > -1) {
      e.preventDefault();
      pick(open, list[i]);
    }
  });
  // Grind changes can make a size unavailable: keep the list's marks in step with the radios
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-form')) document.querySelectorAll('[data-size-menu]').forEach(sync);
  });
})();

/* Brewing guide page ("Jak připravit kávu"): one method at a time (switcher at the top, #v60 opens that method), per method
   a recipe switch (recommended or an expert's), strength, cups, grind with the visitor's grinder, the steps, and a
   full-screen brewing mode with a clock that walks through the timed steps. Each card carries its recipes as JSON
   (sections/main-brew-guide.liquid); the grinder and each method's last recipe, strength and cups are remembered */
(function () {
  var cards = document.querySelectorAll('[data-brew-page-method]');
  if (!cards.length) return;
  var STRENGTH = { mild: 1.08, medium: 1, strong: 0.9 };
  // Roast → water temperature (°C added to the recipe's, which is for a medium roast); filter methods only, the
  // recommended recipe only (an expert's temperature stays as the expert wrote it)
  var ROAST = { light: 3, medium_light: 2, medium: 0, medium_dark: -2, dark: -4 };
  var ROAST_METHODS = ['v60', 'kalita', 'chemex', 'aeropress', 'french-press', 'prekapavac', 'espresso', 'sifon'];
  // Approximate settings per grind level (1 very fine … 6 coarse), from the makers' charts; used when the recipe has no
  // exact value (from the roaster). '' = the grinder isn't made for that grind
  // 'dial: true' = a numbered dial rather than clicks (shown like an electric grinder's setting)
  var GRINDERS = {
    comandante: { exact: 'comandante', steps: ['3–6', '8–14', '18–24', '24–30', '26–32', '32–38'] },
    'timemore-c2': { exact: 'timemore', steps: ['', '6–12', '12–18', '18–22', '20–24', '24–28'] },
    'timemore-c3': { exact: 'timemore', steps: ['', '6–10', '11–18', '18–22', '19–24', '22–26'] },
    // KINGrinder K6 official manual: Turkish 20, espresso 40, moka/AeroPress 65, pour-over 100, French press 120 clicks
    k6: { steps: ['15–25', '35–65', '65–100', '100–120', '120–130', '130–150'] },
    k4: { steps: ['15–40', '40–60', '60–90', '90–120', '120–150', '150+'] },
    // 1Zpresso official charts (K-Ultra: number.click on the outer ring; J-Max and JX: clicks from zero)
    'k-ultra': { dial: true, steps: ['2.0–3.0', '3.0–5.0', '5.5–8.0', '8.0–9.0', '9.0–9.5', '9.5–10.0'] },
    'j-max': { steps: ['70–100', '100–180', '180–260', '260–300', '300–360', '360–400'] },
    jx: { steps: ['15–24', '24–48', '48–72', '72–84', '84–93', '93–102'] },
    encore: { electric: true, steps: ['', '8–10', '12–15', '16–20', '18–22', '28–32'] },
    'encore-esp': { electric: true, steps: ['', '1–20', '21–25', '26–28', '28–31', '32–40'] },
    // De'Longhi burr grinders with an 18-step dial (1 = finest): the six levels spread over the dial, approximate
    delonghi: { electric: true, steps: ['1–2', '3–5', '6–9', '10–12', '13–15', '16–18'] },
    ode: { electric: true, steps: ['', '1–3', '3–6', '6–8', '8–9', '9–11'] },
    'sage-sgp': { electric: true, steps: ['', '1–30', '31–45', '46–50', '50–54', '55–60'] },
    niche: { electric: true, steps: ['0–5', '5–30', '30–40', '40–45', '45–50', '50+'] },
    wilfa: { electric: true, steps: ['', '3–13', '14–22', '22–28', '28–32', '33–41'] },
    calibra: { electric: true, steps: ['', '1–7', '8–15', '16–21', '22–26', '27–39'] }
  };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var roastPick = store.get('sk-roast') || 'medium';
  if (!(roastPick in ROAST)) roastPick = 'medium';
  var grinder = store.get('sk-grinder') || '';
  if (!GRINDERS[grinder]) grinder = '';
  var saved = store.get('sk-brew') || {};
  var num = function (s) { return parseFloat(String(s || '').replace(',', '.')) || 0; };
  var fmt = function (n) { return (Math.round(n * 10) / 10).toString().replace('.', ','); };
  var mmss = function (sec) { sec = Math.max(0, Math.round(sec)); return Math.floor(sec / 60) + ':' + ('0' + (sec % 60)).slice(-2); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
  var parseSteps = function (text) {
    return String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean).map(function (l) {
      var m = l.match(/^(\d{1,2}):(\d{2})\s+(.*)$/);
      return m ? { t: +m[1] * 60 + +m[2], label: m[1] + ':' + m[2], text: m[3] } : { t: null, text: l };
    });
  };
  var setChecked = function (group, attr, value) {
    Array.prototype.forEach.call(group, function (b) { b.setAttribute('aria-checked', String(b.getAttribute(attr) === value)); });
  };
  var updaters = [];
  var afterRender = null; // set by the brewing mode: keeps a running timer in step with its card

  /* The roast and grinder menus open as the same pop-up as the language switcher: the native select stays (hidden)
     and is what the code reads and writes; the pop-up lists its options (optgroups as small titles) */
  var CHECK = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l5 5 10-11"/></svg>';
  var popSeq = 0;
  function enhanceSelect(sel) {
    var wrap = sel.parentNode;
    var id = 'brew-pop-' + (++popSeq);
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'brew-pick__toggle';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', id);
    var label = document.querySelector('label[for="' + sel.id + '"]');
    if (label) btn.setAttribute('aria-label', label.textContent.trim());
    var pop = document.createElement('div');
    pop.className = 'lang-menu__pop brew-pick__pop'; pop.id = id; pop.hidden = true; pop.setAttribute('role', 'listbox');
    var html = '';
    Array.prototype.forEach.call(sel.children, function (node) {
      if (node.tagName === 'OPTGROUP') {
        html += '<p class="lang-menu__label">' + esc(node.label) + '</p>';
        Array.prototype.forEach.call(node.children, function (o) { html += optHtml(o); });
      } else html += optHtml(node);
    });
    function optHtml(o) { return '<button type="button" class="lang-menu__option" role="option" data-value="' + esc(o.value) + '"><span>' + esc(o.textContent) + '</span><span class="brew-pick__check"></span></button>'; }
    pop.innerHTML = html;
    wrap.classList.add('brew-pick');
    wrap.appendChild(btn); wrap.appendChild(pop);
    sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    function sync() {
      var o = sel.options[sel.selectedIndex];
      btn.textContent = o ? o.textContent : '';
      pop.querySelectorAll('[data-value]').forEach(function (b) {
        var on = b.dataset.value === sel.value;
        b.setAttribute('aria-current', String(on)); b.setAttribute('aria-selected', String(on));
        b.querySelector('.brew-pick__check').innerHTML = on ? CHECK : '';
      });
    }
    function setOpen(open) {
      document.querySelectorAll('.brew-pick__pop:not([hidden])').forEach(function (p) { if (p !== pop) { p.hidden = true; p.parentNode.querySelector('.brew-pick__toggle').setAttribute('aria-expanded', 'false'); } });
      pop.hidden = !open; btn.setAttribute('aria-expanded', String(open));
      if (open) place();
      if (open) { var cur = pop.querySelector('[aria-current="true"]') || pop.querySelector('button'); if (cur) cur.focus({ preventScroll: true }); }
    }
    // Long lists (grinders) fit the free space on screen, under the button or above it (below the floating
    // header), and scroll inside the pop-up instead of running over the header or off the page
    function place() {
      var st = pop.style;
      st.maxHeight = ''; st.top = ''; st.bottom = '';
      var r = btn.getBoundingClientRect();
      var hdr = document.querySelector('.header-wrapper.is-sticky .header');
      var topLimit = (hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0) + 8;
      var below = window.innerHeight - r.bottom - 16, above = r.top - topLimit - 16;
      var h = pop.scrollHeight;
      if (h > below && above > below) { st.top = 'auto'; st.bottom = 'calc(100% + 1rem)'; st.maxHeight = Math.max(180, above) + 'px'; }
      else { st.bottom = 'auto'; st.top = 'calc(100% + 1rem)'; st.maxHeight = Math.max(180, below) + 'px'; }
    }
    window.addEventListener('resize', function () { if (!pop.hidden) place(); });
    btn.addEventListener('click', function () { setOpen(pop.hidden); });
    pop.addEventListener('click', function (e) {
      var b = e.target.closest('[data-value]'); if (!b) return;
      sel.value = b.dataset.value; sync(); setOpen(false); btn.focus();
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
    pop.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      var items = Array.prototype.slice.call(pop.querySelectorAll('[data-value]'));
      var i = items.indexOf(document.activeElement) + (e.key === 'ArrowDown' ? 1 : -1);
      if (items[i]) items[i].focus();
    });
    document.addEventListener('click', function (e) { if (!pop.hidden && !wrap.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) { setOpen(false); btn.focus(); } });
    sel._sync = sync; sync();
  }
  document.querySelectorAll('[data-roast-select], [data-grinder-select]').forEach(enhanceSelect);
  // Recipe pop-up: opens under (or above) its button within the free space, scrolls inside, closes on a choice
  document.querySelectorAll('[data-recipe-pick]').forEach(function (pick) {
    var btn = pick.querySelector('[data-recipe-toggle]'), more = pick.querySelector('[data-recipe-more]'), pop = pick.querySelector('.brew-recipes__pop');
    if (!btn || !pop) return;
    function place() {
      var st = pop.style; st.maxHeight = ''; st.top = ''; st.bottom = '';
      var r = btn.getBoundingClientRect();
      var hdr = document.querySelector('.header-wrapper.is-sticky .header');
      var topLimit = (hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0) + 8;
      var below = window.innerHeight - r.bottom - 16, above = r.top - topLimit - 16;
      if (pop.scrollHeight > below && above > below) { st.top = 'auto'; st.bottom = 'calc(100% + 0.6rem)'; st.maxHeight = Math.max(200, above) + 'px'; }
      else { st.bottom = 'auto'; st.top = 'calc(100% + 0.6rem)'; st.maxHeight = Math.max(200, below) + 'px'; }
    }
    function setOpen(open) {
      pop.hidden = !open; btn.setAttribute('aria-expanded', String(open)); if (more) more.setAttribute('aria-expanded', String(open)); pick.classList.toggle('is-open', open);
      if (open) { place(); var cur = pop.querySelector('[aria-checked="true"]') || pop.querySelector('button'); if (cur) cur.focus({ preventScroll: true }); }
    }
    btn.addEventListener('click', function () { setOpen(pop.hidden); });
    if (more) more.addEventListener('click', function () { setOpen(pop.hidden); });
    pop.addEventListener('click', function (e) { if (e.target.closest('[data-preset]')) { setTimeout(function () { setOpen(false); btn.focus({ preventScroll: true }); }, 0); } });
    pop.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      var items = Array.prototype.slice.call(pop.querySelectorAll('[data-preset]'));
      var i = items.indexOf(document.activeElement) + (e.key === 'ArrowDown' ? 1 : -1);
      if (items[i]) items[i].focus();
    });
    document.addEventListener('click', function (e) { if (!pop.hidden && !pick.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) { setOpen(false); btn.focus(); } });
    window.addEventListener('resize', function () { if (!pop.hidden) place(); });
  });

  Array.prototype.forEach.call(cards, function (card) {
    var presets = [];
    try { presets = JSON.parse(card.querySelector('[data-presets]').textContent); } catch (e) { return; }
    var key = card.dataset.key;
    var v = function (name) { return card.querySelector('[data-v="' + name + '"]'); };
    var mem = saved[key] || {};
    var state = { preset: presets[0], strength: mem.strength || 'medium', n: mem.n || null, shots: mem.shots || 2 };
    var hasShots = !!card.querySelector('[data-shots]');
    // A single basket: every gram in the box and the steps halved
    var halve = function (t) { return String(t).replace(/(\d+(?:,\d+)?)(?=(?:\s*[–-]\s*\d+(?:,\d+)?)?\s?g\b)/g, function (m) { return String(Math.round(num(m) / 2)); }); };
    presets.forEach(function (p) { if (p.id === mem.preset) state.preset = p; });
    var baseN = function (p) { return p.cup > 0 ? Math.max(1, Math.round(num(p.liquid) / p.cup)) : 1; };
    var current = { steps: [], title: '', card: card };

    function remember() {
      saved[key] = { preset: state.preset.id, strength: state.strength, n: state.n, shots: state.shots };
      store.set('sk-brew', saved);
    }
    function render() {
      var p = state.preset;
      if (state.n === null) state.n = baseN(p);
      var water0 = num(p.liquid), dose0 = num(p.dose), ratio = p.ratioNum || (dose0 ? water0 / dose0 : 0);
      var scalable = water0 > 0 && ratio > 0 && p.cup > 0;
      var k = scalable ? state.n / baseN(p) : 1;
      var water = water0 * k;
      var ratioEff = ratio * (STRENGTH[state.strength] || 1);
      var dose = scalable ? water / ratioEff : dose0;
      var single = hasShots && state.shots === 1;
      // Whole grams; a milder or stronger cup always differs by at least 1 g from the medium one (small doses like the
      // cezve's would otherwise round to the same number)
      var gramsOf = function (x) {
        var r = Math.round(x);
        if (scalable && state.strength !== 'medium') {
          var mid = Math.round(water / ratio);
          if (state.strength === 'mild' && r >= mid) r = mid - 1;
          if (state.strength === 'strong' && r <= mid) r = mid + 1;
        }
        return String(Math.max(1, r));
      };
      v('dose').textContent = scalable ? gramsOf(dose) + ' g' : (single ? halve(p.dose) : p.dose);
      v('liquid').textContent = scalable ? Math.round(water) + ' g' : (single ? halve(p.liquid) : p.liquid);
      card.querySelectorAll('[data-shots]').forEach(function (b) { b.setAttribute('aria-checked', String(+b.dataset.shots === state.shots)); });
      v('ratio').textContent = scalable && state.strength !== 'medium' ? '1 : ' + fmt(ratioEff) : p.ratio;
      // Amounts in words (Bialetti: a full basket, water to the valve): smaller type, no ratio between them
      card.classList.toggle('is-text-amounts', !scalable && !dose0 && !water0);
      if (p.liquidLabel) v('liquid-label').textContent = p.liquidLabel;
      // Temperature for the roast: the coffee's own (product page) or the one picked (guide page)
      var fixedRoast = card.closest('[data-roast]');
      var roast = fixedRoast ? fixedRoast.dataset.roast : roastPick;
      var tm = String(p.temperature || '').match(/^(\d{2,3})(?:\s*[–-]\s*(\d{2,3}))?\s*°\s*C$/);
      // Experts' recipes too, as long as they give the temperature in degrees
      var roastable = !!tm && ROAST_METHODS.indexOf(key) !== -1;
      var temp = p.temperature;
      if (roastable && ROAST[roast]) {
        var adj = function (n) { return Math.max(80, Math.min(Math.max(96, +n), +n + ROAST[roast])); };
        var lo = adj(tm[1]), hi = tm[2] ? adj(tm[2]) : lo;
        temp = (hi > lo ? lo + '–' + hi : hi) + ' °C';
      }
      v('temperature').textContent = temp;
      var roastBox = v('roast'), roastNote = v('roast-note');
      if (fixedRoast && roastNote) {
        roastNote.textContent = fixedRoast.dataset.roastNote || '';
        roastNote.hidden = !(roastable && ROAST[roast]);
      } else if (roastBox) {
        roastBox.hidden = !roastable;
        setChecked(card.querySelectorAll('button[data-roast]'), 'data-roast', roastPick);
        card.querySelectorAll('[data-roast-select]').forEach(function (sel) { sel.value = roastPick; if (sel._sync) sel._sync(); });
      }
      v('time').textContent = p.time;
      var cupsOut = v('cups');
      // A recipe without grams (Bialetti: a full basket, water to the valve) doesn't scale: the cups stepper goes away
      var cupsCtl = cupsOut && cupsOut.closest('.brew-card__control');
      if (cupsCtl) cupsCtl.hidden = !scalable && water0 === 0 && p.cup > 0;
      if (cupsOut) {
        var n = state.n;
        cupsOut.textContent = n + ' ' + (n === 1 ? card.dataset.one : (n >= 2 && n <= 4 ? card.dataset.few : card.dataset.many));
      }
      setChecked(card.querySelectorAll('[data-preset]'), 'data-preset', p.id);
      var nowEl = card.querySelector('[data-recipe-current]'), row = card.querySelector('.brew-recipes__row[data-preset="' + p.id + '"] .brew-recipes__row-name');
      if (nowEl && row) nowEl.textContent = row.textContent;
      setChecked(card.querySelectorAll('button[data-strength]'), 'data-strength', state.strength);
      card.querySelectorAll('[data-strength-select]').forEach(function (sel) { sel.value = state.strength; });
      // An expert's recipe: one line, name + what is different; who they are in a hint bubble (the theme's hints)
      var about = v('about');
      if (p.author) {
        // The name itself opens who they are: hover on desktop, tap on phones; plain inline text, so it sits on the
        // description's baseline
        about.innerHTML = '<span class="hint brew-about__hint" data-hint><button type="button" class="hint__btn" aria-expanded="false" aria-controls="hint-' + key + '-' + p.id + '">' +
          '<span class="hint__term brew-about__name">' + esc(p.author) + '</span></button><span class="hint__bubble" role="tooltip" id="hint-' + key + '-' + p.id + '" hidden>' + esc(p.bio) + '</span></span>' +
          (p.note ? ' · ' + esc(p.note) : '');
        about.hidden = false;
      } else if (p.note) { about.textContent = p.note; about.hidden = false; }
      else { about.innerHTML = ''; about.hidden = true; }
      // What you need for this recipe (one item per line)
      var gear = v('gear'), gearList = v('gear-list');
      if (gear && gearList) {
        var lines = function (t) { return String(t || '').split(/\n/).map(function (x) { return x.trim(); }).filter(Boolean); };
        var items = lines(p.gear), base = lines(presets[0].gear);
        // Items the chosen recipe needs on top of the basic one get a small mark
        // Read as one sentence: after the first item, common nouns start lower case (brands like Hario or AeroPress keep
        // their capital); items on top of the basic recipe's list are in bold
        var brand = /^(?:Hario|Kalita|Chemex|AeroPress|Bialetti|Melitta|Comandante|Timemore|V60|[A-Z][a-z]*[A-Z])/;
        // (when nothing is shared with the basic list, e.g. a drink, nothing is marked: bold everywhere says nothing)
        var extraOf = function (x) { return p !== presets[0] && base.indexOf(x) < 0; };
        var allExtra = items.every(extraOf);
        gearList.innerHTML = items.map(function (x, i) {
          var t = i > 0 && !brand.test(x) && /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ][a-záčďéěíňóřšťúůýž]/.test(x) ? x.charAt(0).toLowerCase() + x.slice(1) : x;
          return '<li' + (!allExtra && extraOf(x) ? ' class="is-extra"' : '') + '>' + esc(t) + '</li>';
        }).join('');
        gear.hidden = !items.length;
      }
      // The tip follows the chosen recipe too
      var tipBox = v('tip-box'), tipText = v('tip');
      if (tipBox && tipText) { tipText.textContent = p.tip || ''; tipBox.hidden = !p.tip; }
      // Grind level and the grinder's setting
      var lv = p.grindLevel || 0;
      card.querySelectorAll('.grind-line [data-level]').forEach(function (el) {
        var on = +el.dataset.level === lv;
        if (el.tagName === 'I') el.classList.toggle('is-on', on); else el.hidden = !on;
      });
      v('grind').hidden = !lv;
      var clicks = v('clicks'), g = GRINDERS[grinder];
      if (g && lv) {
        var exact = g.exact && p.clicks && p.clicks[g.exact];
        var val = exact || g.steps[lv - 1];
        if (!val) clicks.textContent = card.dataset.unsuited;
        else if (g.electric || g.dial) clicks.textContent = card.dataset.step + ' ' + val + (exact ? '' : ' (' + card.dataset.approx + ')');
        else clicks.textContent = val + ' ' + card.dataset.unit + (exact ? '' : ' (' + card.dataset.approx + ')');
        clicks.hidden = false;
      } else { clicks.hidden = true; }
      card.querySelectorAll('[data-grinder-select]').forEach(function (sel) { sel.value = grinder; if (sel._sync) sel._sync(); });
      // Steps: grams follow the cups (water) and the strength (the coffee: the number equal to the recipe's dose), in bold
      var steps = parseSteps(p.steps).map(function (st) {
        st.text = st.text.replace(/(\d+(?:,\d+)?)(\s?g\b)/g, function (m, n, unit) {
          if (!scalable) return single ? halve(m) : m;
          return (num(n) === dose0 ? gramsOf(dose) : Math.round(num(n) * k)) + unit;
        });
        return st;
      });
      // The water temperature in the first pour ("Zalijte 30 g vody (90 °C) …"), the one the card shows now
      // (it follows the roast); steps that already give a temperature stay as they are
      // only a plain temperature ("90 °C", "93–94 °C"), not a note like "Pokojová, ohřát na 95 °C"
      if (tm && /^\d{2,3}(?:\s*[–-]\s*\d{2,3})?\s*°\s*C$/.test(String(temp || '').trim())) {
        var tempTxt = String(temp).replace(/\s+/g, '\u00a0');
        steps.some(function (st) {
          if (/°\s*C/.test(st.text)) return /(?:zalijte|nalijte|dolijte|pour)/i.test(st.text);
          var t2 = st.text.replace(/(\d+(?:,\d+)?\s?g\s+(?:(?:horké|hot)\s+)?(?:vody|of (?:hot )?water))/i, '$1 (' + tempTxt + ')');
          if (t2 !== st.text) { st.text = t2; return true; }
          return false;
        });
      }
      // The grind in the dose step too ("Nasypte 15 g středně jemně mleté kávy"), unless the step already says it
      var grindWords = (card.dataset.grindAdj || '').split('|'), gw = p.grindLevel ? grindWords[p.grindLevel - 1] : '';
      if (gw) steps.some(function (st) {
        if (/mlet|ground|grind/i.test(st.text)) return false;
        var t2 = st.text.replace(/(\d+(?:,\d+)?(?:\s*[–-]\s*\d+(?:,\d+)?)?\s?g)\s+kávy/, '$1 ' + gw + ' mleté kávy')
          .replace(/(\d+(?:\.\d+)?(?:\s*[–-]\s*\d+)?\s?g)\s+of\s+coffee/i, '$1 of ' + gw + ' ground coffee');
        if (t2 !== st.text) { st.text = t2; return true; }
        return false;
      });
      var ol = v('steps');
      // Get ready: the steps before the first timed one go above the timer (only when the timer shows)
      var nT = steps.filter(function (st) { return st.t !== null; }).length, firstT = -1;
      steps.some(function (st, i) { if (st.t !== null) { firstT = i; return true; } return false; });
      var splitAt = v('prep') && nT >= 2 && firstT > 0 ? firstT : 0;
      // Each step: its time (if any), the text, the running clock while it's under way, and a circle to tick it off
      var SCALE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 5.5h14"/><path d="M12 5.5V9"/><path d="M4.5 20 6 9h12l1.5 11z"/><path d="M10 14.5h4"/></svg>';
      var stepLi = function (st) {
        var text = esc(st.text).replace(/(\d+(?:,\d+)?(?:\s*[–-]\s*\d+(?:,\d+)?)?)\s?g\b/g, '<b>$1\u00a0g</b>');
        // The step that zeroes the scale gets a small "⚖ 0 g" tag, so it is not missed when reading quickly
        var tare = /vynulujte|\btare\b/i.test(st.text) ? '<span class="brew-step__tare" aria-hidden="true">' + SCALE_ICON + '0\u00a0g</span>' : '';
        return '<li class="brew-step' + (tare ? ' has-tare' : '') + '"><span class="brew-page__step-time">' + (st.t !== null ? st.label : '') + '</span>' +
          '<span class="brew-step__text">' + text + tare + '</span><span class="brew-step__clock" aria-hidden="true"></span>' +
          '<button type="button" class="brew-step__check" aria-pressed="false" aria-label="' + esc(card.dataset.stepDone || '') + '">' + CHECK + '</button></li>';
      };
      if (v('prep')) { v('prep').innerHTML = steps.slice(0, splitAt).map(stepLi).join(''); v('prep-box').hidden = splitAt === 0; }
      // What you need ("Potřeby"): its own heading and one line of text above Příprava, always in sight
      var gearBox = v('gear');
      if (gearBox) {
        if (gearBox._home && gearBox.parentNode !== gearBox._home.parent) gearBox._home.parent.insertBefore(gearBox, gearBox._home.next);
        gearBox.classList.add('brew-gear--line');
      }
      // The running timer may sit in the list (the step under way inside it): take it home before the list is rewritten
      var lvDock = card.querySelector('[data-live]'); if (lvDock && lvDock._home && ol.contains(lvDock)) { lvDock._home.appendChild(lvDock); lvDock.classList.remove('is-docked'); }
      ol.innerHTML = steps.slice(splitAt).map(stepLi).join('');
      // Long methods: fold all but the first steps away (the button shows how many there are)
      // (3 or more steps in the list under the timer: the first one shows, the rest fold behind the ghost step)
      var fb = card.querySelector('[data-fold-toggle]'), nOl = steps.length - splitAt, foldIt = nOl >= FOLD_AT && nOl > FOLD_SHOW;
      ol.classList.toggle('is-foldable', foldIt);
      if (!foldIt) ol.classList.remove('is-open');
      Array.prototype.forEach.call(ol.children, function (li, i) { li.dataset.i = i; li.classList.toggle('is-folded', foldIt && i >= FOLD_SHOW); });
      if (fb) { fb.hidden = !foldIt; fb._n = nOl; foldLabel(card); }
      current.steps = steps.filter(function (st) { return st.t !== null; });
      current.title = card.dataset.name + (p.author ? ' · ' + p.author : '');
      // Full screen subtitle: "by Silný Kafe" for ours, "by <author>" for an expert's, just the name for a popular method or a drink
      current.method = card.dataset.name;
      current.recipe = p.author ? 'BY ' + p.author : (p.id === 'roaster' ? 'BY ' + (p.label || '') : (p.label || ''));
      var start = card.querySelector('[data-timer]');
      if (start) {
        start.hidden = current.steps.length < 2;
        if (current.steps.length) v('total').textContent = mmss(current.steps[current.steps.length - 1].t);
      }
      if (afterRender) afterRender(card, current);
    }

    card.addEventListener('click', function (e) {
      // A step is ticked off by a tap anywhere on its row (the circle on the line is the tick box)
      if (e.target.closest('[data-live]') && !e.target.closest('li.brew-step')) return;
      var row = e.target.closest('li.brew-step');
      var b = row && card.contains(row) && !e.target.closest('a') ? row.querySelector('.brew-step__check') : e.target.closest('button');
      if (!b || !card.contains(b)) return;
      if (b.classList.contains('brew-step__check')) {
        var li = b.closest('li'), on = !li.classList.contains('is-checked');
        li.classList.toggle('is-checked', on); b.setAttribute('aria-pressed', String(on));
        // The last preparation step ticked: let the tick show for a moment, then fold the list
        if (li.closest('[data-v="prep"]')) { clearTimeout(card._prepT); card._prepT = setTimeout(function () { foldPrep(card); }, on ? 650 : 0); }
        return;
      }
      if (b.dataset.preset) {
        presets.forEach(function (p) { if (p.id === b.dataset.preset) state.preset = p; });
        state.n = null;
      } else if (b.dataset.roast) {
        roastPick = b.dataset.roast; store.set('sk-roast', roastPick);
        updaters.forEach(function (u) { u(); }); return;
      } else if (b.dataset.shots) {
        state.shots = +b.dataset.shots;
      } else if (b.hasAttribute('data-strength') && b.dataset.strength) {
        state.strength = b.dataset.strength;
      } else if (b.dataset.brewStep) {
        state.n = Math.min(12, Math.max(1, (state.n || 1) + parseInt(b.dataset.brewStep, 10)));
      } else if (b.hasAttribute('data-mode-open')) {
        openMode(current); return;
      } else return;
      render(); remember();
    });
    // Strength and roast menus
    card.addEventListener('change', function (e) {
      if (e.target.matches('[data-strength-select]')) { state.strength = e.target.value; render(); remember(); }
      else if (e.target.matches('[data-roast-select]')) {
        roastPick = e.target.value; store.set('sk-roast', roastPick);
        updaters.forEach(function (u) { u(); });
      }
    });
    updaters.push(render);
    render();
  });

  // One grinder for the whole page: picking it in any card sets all cards
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-grinder-select]')) return;
    grinder = e.target.value;
    store.set('sk-grinder', grinder);
    updaters.forEach(function (u) { u(); });
  });

  /* One method at a time: on the guide page (a switcher at the top, #v60 in the address) and in the product page's box (pills) */
  document.querySelectorAll('[data-brew-root]').forEach(function (root) {
    var rootCards = root.querySelectorAll('[data-brew-page-method]');
    var links = root.querySelectorAll('[data-switch]');
    var useHash = root.hasAttribute('data-brew-hash');
    var switcher = root.querySelector('.brew-switch');
    var keys = {};
    Array.prototype.forEach.call(rootCards, function (c) { keys[c.dataset.key] = c; });
    // Where the bottom of the floating header will be once the glide ends, so the page moves in one go:
    // phones hide the header while scrolling down; on desktop it shrinks into the pill (measured in that state,
    // with transitions frozen, then put back before anything is painted)
    function headerBottomAfter(down) {
      var wrap = document.querySelector('.header-wrapper.is-sticky');
      if (!wrap) return 0;
      var bar = wrap.querySelector('.header') || wrap;
      if (window.matchMedia('(max-width: 989px)').matches) return down ? 0 : Math.max(0, bar.getBoundingClientRect().bottom);
      var section = wrap.closest('.section-header') || wrap;
      var was = wrap.classList.contains('is-scrolled');
      wrap.classList.add('is-frozen', 'is-scrolled');
      var stickTop = parseFloat(getComputedStyle(section).top) || 0;
      var b = bar.getBoundingClientRect().bottom - section.getBoundingClientRect().top + stickTop;
      if (!was) wrap.classList.remove('is-scrolled');
      void wrap.offsetWidth;
      wrap.classList.remove('is-frozen');
      return Math.max(0, b);
    }
    function glideTo(card) {
      var gap = card === switcher ? 4 : 16;
      var rawTop = card.getBoundingClientRect().top + window.scrollY;
      var down = rawTop - gap > window.scrollY;
      var top = Math.max(0, rawTop - headerBottomAfter(down) - gap);
      if (Math.abs(window.scrollY - top) <= 8) return;
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: calm ? 'auto' : 'smooth' });
    }
    function show(key, scroll) {
      if (!keys[key]) key = rootCards[0].dataset.key;
      Array.prototype.forEach.call(rootCards, function (c) { c.hidden = c.dataset.key !== key; });
      Array.prototype.forEach.call(links, function (a) {
        var on = a.dataset.switch === key;
        a.setAttribute('aria-current', String(on)); a.setAttribute('aria-selected', String(on));
        if (on && a.parentNode.scrollWidth > a.parentNode.clientWidth) a.parentNode.scrollTo({ left: a.offsetLeft - a.parentNode.clientWidth / 2 + a.offsetWidth / 2, behavior: 'smooth' });
      });
      // Collapsed (three methods): of the extra ones only the chosen one stays in sight
      var moreTile = root.querySelector('[data-brew-more]');
      if (moreTile && !moreTile.hidden) {
        root.querySelectorAll('.brew__tab--extra').forEach(function (t) { t.hidden = t.dataset.switch !== key; });
        var cnt = moreTile.querySelector('.brew__more-count'); if (cnt) cnt.textContent = '+' + root.querySelectorAll('.brew__tab--extra[hidden]').length;
      }
      // Glide down to the chosen recipe, the method switcher staying in sight just under the floating header
      if (scroll && keys[key]) glideTo(switcher || keys[key]);
    }
    root.classList.add('is-single');
    if (useHash) {
      var fromHash = location.hash.slice(1);
      show(keys[fromHash] ? fromHash : (store.get('sk-brew-method') || ''), false);
      if (keys[fromHash] && switcher) requestAnimationFrame(function () { window.scrollTo(0, switcher.getBoundingClientRect().top + window.scrollY - 8); });
      window.addEventListener('hashchange', function () { var k = location.hash.slice(1); if (keys[k]) show(k, true); });
    } else {
      show(root.dataset.first || '', false);
    }
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-brew-more]');
      if (more && root.contains(more)) {
        more.hidden = true;
        root.querySelectorAll('.brew__tab--extra').forEach(function (t) { t.hidden = false; });
        var lessBtn = root.querySelector('[data-brew-less]'); if (lessBtn) lessBtn.hidden = false;
        var first = root.querySelector('.brew__tab--extra');
        if (first) first.focus();
        return;
      }
      // "Méně": back to three methods (the chosen one stays in sight if it was among the extra ones)
      var less = e.target.closest('[data-brew-less]');
      if (less && root.contains(less)) {
        less.hidden = true;
        root.querySelectorAll('.brew__tab--extra').forEach(function (t) { t.hidden = t.getAttribute('aria-selected') !== 'true'; });
        var moreBtn = root.querySelector('[data-brew-more]');
        if (moreBtn) { moreBtn.hidden = false; moreBtn.querySelector('.brew__more-count').textContent = '+' + root.querySelectorAll('.brew__tab--extra[hidden]').length; moreBtn.focus(); }
        return;
      }
      var a = e.target.closest('[data-switch], a[href^="#"]');
      if (!a || !root.contains(a)) return;
      var key = a.dataset.switch || a.getAttribute('href').slice(1);
      if (!keys[key]) return;
      e.preventDefault();
      if (useHash) { history.replaceState(null, '', '#' + key); store.set('sk-brew-method', key); }
      show(key, useHash);
    });
  });

  /* Brewing mode */
  var mode = document.querySelector('[data-brew-mode]');
  if (!mode) return;
  var q = function (sel) { return mode.querySelector(sel); };
  var bar = q('[data-mode-bar]'), R = 2 * Math.PI * 54;
  bar.style.strokeDasharray = R; bar.style.strokeDashoffset = R;
  var run = { steps: [], running: false, start: 0, elapsed: 0, raf: 0, idx: -1, total: 0, sig: '', text: '' };
  // The small pill while the brewing mode is hidden: clock and the current step; tap = back to the full screen
  var mini = document.querySelector('[data-brew-mini]');
  var miniQ = function (sel) { return mini && mini.querySelector(sel); };
  var miniR = 2 * Math.PI * 20;
  if (mini) { var mb = mini.querySelector('[data-mini-bar]'); if (mb) mb.style.strokeDasharray = miniR; }
  // Tablet and desktop: the timer runs in its card (in place of the start button), the full screen only on request;
  // phones open the full screen, and the pill keeps the clock when it's hidden
  var wide = window.matchMedia('(min-width: 750px)');
  var live = null, liveR = 2 * Math.PI * 21;
  function liveIn(card) { return card && card.querySelector('[data-live]'); }
  // Tablet and desktop: the timer lives in the card; once the card's timer box scrolls out of sight, the floating pill
  // takes over (and goes again when the box is back in view)
  var liveOut = false, liveIO = window.IntersectionObserver ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { liveOut = !e.isIntersecting; }); syncPill();
  }) : null;
  function syncPill() {
    if (!mini || !wide.matches) return;
    var t = elapsed(), on = !!live && liveOut && mode.hidden && t > 0 && t < run.total;
    if (mini.hidden === !on) return;
    mini.hidden = !on; if (on) draw();
  }
  function hideLive() {
    if (liveIO) liveIO.disconnect(); liveOut = false;
    if (mini && wide.matches) mini.hidden = true;
    if (!live) return;
    undock(live);
    live.hidden = true; (live._home || live.parentNode).classList.remove('is-live'); live = null;
  }
  // Desktop: the timer box sits in the list and holds the step under way; finished steps rise out of it above, the next
  // one comes up into it from below (the box stays where it is on the screen, the steps move through it)
  function undock(l) {
    var slot = l.closest('.brew-live-slot');
    if (!slot) return;
    var now = l.querySelector('.brew-live__now');
    if (now) Array.prototype.slice.call(now.children).forEach(function (li) { slot.parentNode.insertBefore(li, slot); });
    l._home.appendChild(l); slot.remove(); l.classList.remove('is-docked');
  }
  function dock(timed, idx, settle) {
    if (!live || !timed.length) { if (settle) settle(); return; }
    var cur = timed[Math.max(0, Math.min(idx, timed.length - 1))];
    var now = live.querySelector('.brew-live__now');
    if (now && now.firstElementChild === cur) { if (settle) settle(); return; }
    var ol = cur.closest('[data-v="steps"]'); if (!ol) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var docked = !!live.closest('.brew-live-slot');
    // First: where everything is now
    var els = timed.concat([live]), before = els.map(function (e) { return e.getBoundingClientRect().top; });
    var boxTop = live.getBoundingClientRect().top;
    if (!now) { now = document.createElement('ol'); now.className = 'brew__steps brew-page__steps brew-live__now'; live.appendChild(now); }
    var slot = live.closest('.brew-live-slot');
    if (!slot) { slot = document.createElement('li'); slot.className = 'brew-live-slot'; }
    // The step that was in the box goes back above it; the box moves to the step under way and takes it in
    Array.prototype.slice.call(now.children).forEach(function (li) { ol.insertBefore(li, slot.parentNode ? slot : cur); });
    ol.insertBefore(slot, cur); if (live.parentNode !== slot) slot.appendChild(live);
    now.appendChild(cur); live.classList.add('is-docked');
    // Fold what's done before measuring, so the box and the steps glide straight to their final places (no second jump)
    if (settle) settle();
    if (!docked) return;
    // Keep the box still on the screen, and let the steps glide to their places
    var shift = live.getBoundingClientRect().top - boxTop;
    if (shift) window.scrollBy(0, shift);
    if (reduce || !live.animate) return;
    els.forEach(function (e, i) {
      var dy = before[i] - e.getBoundingClientRect().top;
      if (Math.abs(dy) > 1) e.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }], { duration: 550, easing: 'cubic-bezier(.3, .7, .3, 1)' });
    });
  }
  function hideAway() { if (mini) mini.hidden = true; hideLive(); }
  function showLive() {
    var l = liveIn(run.card);
    if (!l) return false;
    if (mini) mini.hidden = true;
    live = l; l.style.setProperty('--r', liveR); l.querySelector('[data-live-bar]').style.strokeDasharray = liveR;
    l._home = l._home || l.parentNode;
    l.hidden = false; l._home.classList.add('is-live');
    if (liveIO) { liveIO.disconnect(); liveIO.observe(l); }
    if (run.card) markSteps(Math.max(0, run.idx));
    return true;
  }
  // A card re-rendered while its timer runs: other steps (recipe, cups, strength changed) stop the timer; the same steps
  // (grinder, roast) keep it, with the step under way marked again
  function sigOf(cur) { return cur.title + '|' + cur.steps.map(function (st) { return st.t + st.text; }).join('|'); }
  afterRender = function (card, cur) {
    if (run.card !== card || !run.sig) return;
    if (sigOf(cur) !== run.sig) { stopMode(); if (!mode.hidden) { mode.hidden = true; document.documentElement.classList.remove('is-brewing'); } }
    else markSteps(Math.max(0, run.idx));
  };
  // The step under way in the card's list: highlighted, the ones before it faded
  function markSteps(idx) {
    if (!run.card) return;
    var timed = Array.prototype.filter.call(run.card.querySelectorAll('[data-v="steps"] li.brew-step'), function (li) { var t = li.querySelector('.brew-page__step-time'); return t && t.textContent; });
    timed.forEach(function (li, i) {
      li.classList.toggle('is-now', i === idx); li.classList.toggle('is-done', idx > -1 && i < idx);
      var c = li.querySelector('.brew-step__check'); if (c) c.setAttribute('aria-pressed', String(li.classList.contains('is-checked') || (idx > -1 && i < idx)));
      if (i !== idx) { var k = li.querySelector('.brew-step__clock'); if (k) k.textContent = ''; }
    });
    // Folded list: the step under way and the one after it are always out; the rest stay folded until they come near
    if (idx > -1 && timed[idx]) foldReveal(run.card, +(timed[idx].dataset.i || 0) + 1);
    var upTo = idx > -1 && timed[idx] && !run.allDone ? +(timed[idx].dataset.i || 0) : 0, card = run.card;
    // Once the box has taken the new step (the finished one is back in the list), everything done folds into the row
    var settle = function () { foldDone(card, upTo, idx > -1 && !run.allDone); };
    if (live && idx > -2 && run.card.contains(live._home || live)) dock(timed, idx, settle); else settle();
  }
  var sound = store.get('sk-brew-sound') !== false, wake = null, audio = null, lastFocus = null;
  q('[data-mode-sound]').setAttribute('aria-pressed', String(sound));
  function beep() {
    if (navigator.vibrate) navigator.vibrate([90, 60, 90]);
    if (!sound) return;
    try {
      audio = audio || new (window.AudioContext || window.webkitAudioContext)();
      var o = audio.createOscillator(), gn = audio.createGain();
      o.frequency.value = 880; gn.gain.setValueAtTime(0.0001, audio.currentTime);
      gn.gain.exponentialRampToValueAtTime(0.25, audio.currentTime + 0.02);
      gn.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + 0.35);
      o.connect(gn); gn.connect(audio.destination); o.start(); o.stop(audio.currentTime + 0.4);
    } catch (e) {}
  }
  // The 3-2-1 before a step: a short, softer tick each second
  function tick() {
    if (!sound) return;
    try {
      audio = audio || new (window.AudioContext || window.webkitAudioContext)();
      var o = audio.createOscillator(), gn = audio.createGain();
      o.frequency.value = 660; gn.gain.setValueAtTime(0.0001, audio.currentTime);
      gn.gain.exponentialRampToValueAtTime(0.12, audio.currentTime + 0.01);
      gn.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + 0.12);
      o.connect(gn); gn.connect(audio.destination); o.start(); o.stop(audio.currentTime + 0.15);
    } catch (e) {}
  }
  function keepAwake() {
    if (!('wakeLock' in navigator) || (mode.hidden && !run.running) || wake) return;
    navigator.wakeLock.request('screen').then(function (l) { wake = l; }).catch(function () {});
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { wake = null; keepAwake(); } });
  function elapsed() { return run.elapsed + (run.running ? (Date.now() - run.start) / 1000 : 0); }
  // The weight the scale should reach in a step: "… do 120 g" / "… up to 120 g", or the first pour ("Zalijte 30 g …")
  function scaleTarget(text, i) {
    var m = String(text || '').match(/(?:\bdo|\bup to)\s+(\d+(?:[,.]\d+)?(?:\s*[–-]\s*\d+(?:[,.]\d+)?)?)\s?g\b/i);
    if (!m && i === 0) m = String(text || '').match(/(?:zalijte|nalijte|pour)\s+(\d+(?:[,.]\d+)?)\s?g\b/i);
    return m ? m[1].replace(/\s+/g, '') + '\u00a0g' : '';
  }
  function draw() {
    var t = elapsed(), idx = -1;
    run.steps.forEach(function (st, i) { if (st.t <= t) idx = i; });
    var done = t >= run.total;
    // The ring is the step under way: the big number is the time it has left, the ring fills as it runs;
    // the whole brew is small under it and on the timeline below
    var sIdx = Math.max(0, idx), sFrom = run.steps[sIdx] ? run.steps[sIdx].t : 0, sNext = run.steps[sIdx + 1], sTo = sNext ? sNext.t : run.total;
    var sLeft = Math.max(0, Math.ceil(sTo - t)), sFrac = done ? 1 : Math.max(0, Math.min(1, sTo > sFrom ? (t - sFrom) / (sTo - sFrom) : 1));
    // Done: a tick in the ring in place of the clock
    var clk = q('[data-mode-clock]'), clkText = done ? '' : mmss(sLeft); if (clk.textContent !== clkText) clk.textContent = clkText;
    mode.classList.toggle('is-done', done);
    // Done: the "hide" arrow becomes a close ×
    var mc = q('[data-mode-close]'), ml = done ? mode.dataset.closeLabel : mode.dataset.minLabel;
    if (mc && ml && mc.getAttribute('aria-label') !== ml) { mc.setAttribute('aria-label', ml); mc.title = ml; }
    var tot = q('[data-mode-total]'); if (tot.textContent) tot.textContent = '';
    bar.style.strokeDashoffset = R * (1 - sFrac);
    mode.querySelectorAll('[data-mode-dots] li').forEach(function (li, i) {
      var a = run.steps[i].t, z = run.steps[i + 1] ? run.steps[i + 1].t : run.total;
      li.style.setProperty('--fill', String(Math.max(0, Math.min(1, z > a ? (t - a) / (z - a) : (t >= a ? 1 : 0)))));
    });
    if (idx !== run.idx) {
      if (run.idx !== -1 || idx > 0) beep();
      run.idx = idx;
      var st = run.steps[Math.max(0, idx)];
      q('[data-mode-step]').innerHTML = esc(st.text).replace(/(\d+(?:,\d+)?)\s?g\b/g, '<b>$1\u00a0g</b>');
      run.text = st.text;
      run.target = scaleTarget(st.text, Math.max(0, idx));
      var tg = q('[data-mode-target]'); if (tg) { tg.hidden = !run.target; q('[data-mode-target-g]').textContent = run.target; }
      markSteps(Math.max(0, idx));
      mode.querySelectorAll('[data-mode-dots] li').forEach(function (li, i) { li.className = i < idx ? 'is-done' : (i === idx ? 'is-on' : ''); });
    }
    var nx = run.steps[idx + 1];
    // The last three seconds before the next step: 3, 2, 1 (a tick each, the coming step marked, the countdown pulses)
    var soon = run.running && nx ? Math.ceil(nx.t - t) : 0;
    if (soon < 1 || soon > 3) soon = 0;
    if (soon && run.cd !== idx + ':' + soon) { run.cd = idx + ':' + soon; tick(); }
    mode.classList.toggle('is-soon', !!soon);
    // Full screen: the 3, 2, 1 big in the ring, in place of the clock
    var cnt = q('[data-mode-count]');
    if (cnt) { var cntText = soon ? String(soon) : ''; if (cnt.textContent !== cntText) { cnt.textContent = cntText; cnt.hidden = !soon; if (soon) { cnt.classList.remove('is-pop'); void cnt.offsetWidth; cnt.classList.add('is-pop'); } } }
    if (mini) mini.classList.toggle('is-soon', !!soon);
    if (run.card) {
      var cl = run.card.querySelectorAll('[data-v="steps"] li.brew-step'), nowLi = run.card.querySelector('[data-v="steps"] li.is-now');
      var clA = Array.prototype.slice.call(cl), nextLi = nowLi ? clA[clA.indexOf(nowLi) + 1] : null;
      clA.forEach(function (li) { li.classList.toggle('is-soon', !!soon && li === nextLi); });
      if (nowLi) nowLi.classList.toggle('is-counting', !!soon);
    }
    // The countdown belongs to the step under way ("ještě 0:28" under it); the next step is just named
    q('[data-mode-next]').textContent = nx && !done ? mode.dataset.next + ': ' + nx.text.replace(/(\d)\s?g\b/g, '$1\u00a0g') : '';
    // Done: just "Hotovo, dobrou chuť!" in place of the last step, nothing under it
    if (done) {
      var dStep = q('[data-mode-step]'); if (dStep.textContent !== mode.dataset.done) dStep.textContent = mode.dataset.done;
      var dTg = q('[data-mode-target]'); if (dTg && !dTg.hidden) dTg.hidden = true;
    }
    var mLeft = q('[data-mode-left]');
    if (mLeft) mLeft.hidden = true;
    if (false) { var mlText = done ? '' : ((run.card && run.card.dataset.stepLeft) || '%s').replace('%s', mmss(Math.max(0, Math.ceil((nx ? nx.t : run.total) - t)))); if (mLeft.textContent !== mlText) mLeft.textContent = mlText; }
    if (run.card) {
      // Under the step under way: how long until the next one
      var nowClock = run.card.querySelector('[data-v="steps"] li.is-now .brew-step__clock');
      if (nowClock) { var nxc = run.steps[run.idx + 1], ncText = done ? '' : (run.card.dataset.stepLeft || '%s').replace('%s', mmss(Math.max(0, Math.ceil((nxc ? nxc.t : run.total) - t)))); if (nowClock.textContent !== ncText) nowClock.textContent = ncText; }
    }
    if (live) {
      var lc = live.querySelector('[data-live-clock]'), lcText = done ? mmss(run.total) : mmss(sLeft);
      if (lc.textContent !== lcText) lc.textContent = lcText;
      var lt2 = live.querySelector('[data-live-total]'); if (lt2 && !lt2.textContent) lt2.textContent = '/ ' + mmss(run.total);
      // The step under way (what to do now), the same as in the list and on the full screen
      var ls = done ? mode.dataset.done : (run.text || '').replace(/(\d)\s?g\b/g, '$1\u00a0g');
      var lsEl = live.querySelector('[data-live-step]'); if (lsEl.textContent !== ls) lsEl.textContent = ls;
      var ltg = live.querySelector('[data-live-target]');
      if (ltg) { var ltgOn = !done && !!run.target; if (ltg.hidden === ltgOn) ltg.hidden = !ltgOn; var ltgB = live.querySelector('[data-live-target-g]'); if (ltgB.textContent !== (run.target || '')) ltgB.textContent = run.target || ''; }
      live.querySelector('[data-live-bar]').style.strokeDashoffset = liveR * (1 - sFrac);
      // Only when it changes: rewriting the button's text every frame swallows clicks (Safari)
      var lt = live.querySelector('[data-live-toggle]'), ltText = done ? (mode.dataset.again || mode.dataset.start) : (run.running ? mode.dataset.pause : mode.dataset.start);
      if (lt.textContent !== ltText) lt.textContent = ltText;
    }
    if (mini && !mini.hidden) {
      // Clock of the whole brew, what comes next and in how long; the ring round the pause button fills up.
      // Text only when it changes (rewriting it every frame swallows taps in Safari)
      // What to do now (up to two lines), and the big clock counts down to the next step (on the last step: to the end)
      var mnx = run.steps[run.idx + 1];
      var mc = miniQ('[data-mini-clock]'), mcText = done ? mmss(run.total) : mmss(Math.max(0, Math.ceil((mnx ? mnx.t : run.total) - t)));
      if (mc.textContent !== mcText) mc.textContent = mcText;
      var gfix = function (s) { return s.replace(/(\d)\s?g\b/g, '$1\u00a0g'); };
      var ms = done ? mode.dataset.done : gfix(run.text || '');
      var msEl = miniQ('[data-mini-step]'); if (msEl.textContent !== ms) msEl.textContent = ms;
      miniQ('[data-mini-bar]').style.strokeDashoffset = miniR * (1 - Math.min(1, run.total ? t / run.total : 0));
      mini.classList.toggle('is-paused', !run.running && !done);
      mini.classList.toggle('is-done', done);
      var mtl = done ? mode.dataset.done : (run.running ? mode.dataset.pause : mode.dataset.start);
      var mt = miniQ('[data-mini-toggle]'); if (mt.getAttribute('aria-label') !== mtl) mt.setAttribute('aria-label', mtl);
      // Done: the pill says so for a few seconds, then goes away by itself
      if (done && !mini._bye) mini._bye = setTimeout(function () { mini._bye = 0; if (elapsed() >= run.total) stopMode(); }, 8000);
    }
    // The end: every step ticked off, a tick in the ring
    if (live) live.classList.toggle('is-done', done);
    if (done && !run.allDone && run.card) {
      run.allDone = true;
      // The end: the list stays folded, everything done goes into the one ticked row
      foldDone(run.card, 999, true);
      Array.prototype.forEach.call(run.card.querySelectorAll('[data-v="steps"] li.brew-step'), function (li) {
        li.classList.remove('is-now', 'is-soon', 'is-counting'); li.classList.add('is-done');
        var c = li.querySelector('.brew-step__check'); if (c) c.setAttribute('aria-pressed', 'true');
        var k = li.querySelector('.brew-step__clock'); if (k) k.textContent = '';
      });
    }
    if (done && run.running) {
      run.running = false; run.elapsed = run.total; q('[data-mode-toggle]').textContent = mode.dataset.again || mode.dataset.start;
      if (wake && mode.hidden) { wake.release().catch(function () {}); wake = null; }
      return;
    }
    if (run.running) run.raf = requestAnimationFrame(draw);
  }
  function setRunning(on) {
    if (on === run.running) return;
    if (on) { if (elapsed() >= run.total) { run.elapsed = 0; run.idx = -1; run.allDone = false; } run.start = Date.now(); run.running = true; run.raf = requestAnimationFrame(draw); }
    else { run.elapsed = elapsed(); run.running = false; cancelAnimationFrame(run.raf); }
    q('[data-mode-toggle]').textContent = run.running ? mode.dataset.pause : mode.dataset.start;
  }
  function showMode() {
    hideAway();
    mode.hidden = false;
    document.documentElement.classList.add('is-brewing');
    keepAwake();
    q('[data-mode-toggle]').focus();
  }
  function openMode(cur) {
    lastFocus = document.activeElement;
    var sig = sigOf(cur);
    try { audio = audio || new (window.AudioContext || window.webkitAudioContext)(); audio.resume(); } catch (e) {}
    // The same recipe still brewing (hidden or paused): back to it, the clock doesn't restart
    if (sig === run.sig && elapsed() > 0 && elapsed() < run.total) {
      if (wide.matches && showLive()) { draw(); return; }
      showMode(); draw(); return;
    }
    setRunning(false);
    run.sig = sig; run.card = cur.card;
    run.steps = cur.steps.slice(); run.total = run.steps[run.steps.length - 1].t;
    // Starting the timer means the preparation is done: its steps (the ones without a time) tick themselves off
    run.allDone = false;
    // (they sit above the timer since the split, so both lists are looked at)
    if (cur.card) Array.prototype.forEach.call(cur.card.querySelectorAll('[data-v="prep"] li.brew-step, [data-v="steps"] li.brew-step'), function (li) {
      var tm = li.querySelector('.brew-page__step-time');
      if (tm && !tm.textContent) { li.classList.add('is-checked'); var c = li.querySelector('.brew-step__check'); if (c) c.setAttribute('aria-pressed', 'true'); }
    });
    if (cur.card) foldPrep(cur.card);
    run.elapsed = 0; run.idx = -1;
    document.querySelectorAll('[data-live-total]').forEach(function (e) { e.textContent = ''; });
    // Full screen: the method, and under it smaller the recipe (ours or the expert's)
    q('[data-mode-title]').textContent = cur.method || cur.title;
    var rcp = q('[data-mode-recipe]'); if (rcp) { rcp.textContent = (cur.recipe || '').replace(/^BY /, (mode.dataset.by || 'by') + ' '); rcp.hidden = !cur.recipe; }
    if (mini) miniQ('[data-mini-title]').textContent = cur.title.replace(/\s*\(.*\)\s*$/, '');
    q('[data-mode-total]').textContent = '';
    // Timeline: one segment per step, as long as the step lasts
    q('[data-mode-dots]').innerHTML = run.steps.map(function (st, i) { var z = run.steps[i + 1] ? run.steps[i + 1].t : run.total; return z > st.t ? '<li style="flex-grow:' + (z - st.t) + '"></li>' : '<li hidden></li>'; }).join('');
    if (wide.matches && showLive()) { draw(); setRunning(true); keepAwake(); return; }
    showMode();
    draw(); setRunning(true);
  }
  // Hiding doesn't stop anything: while a brew is under way the pill keeps the clock in sight (and the screen on)
  function closeMode() {
    mode.hidden = true;
    document.documentElement.classList.remove('is-brewing');
    var t = elapsed();
    if (t > 0 && t < run.total) {
      if (wide.matches && showLive()) draw();
      else if (mini) { mini.hidden = false; draw(); }
      else stopMode();
    } else stopMode();
    if (lastFocus) lastFocus.focus();
  }
  function stopMode() {
    if (mini && mini._bye) { clearTimeout(mini._bye); mini._bye = 0; }
    setRunning(false);
    run.elapsed = 0; run.idx = -1; run.sig = '';
    markSteps(-2);
    hideAway();
    if (wake) { wake.release().catch(function () {}); wake = null; }
  }
  document.addEventListener('click', function (e) {
    if (!live || !live.contains(e.target)) return;
    var b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-live-stop')) stopMode();
    else if (b.hasAttribute('data-live-open')) { lastFocus = b; showMode(); draw(); }
    else if (b.hasAttribute('data-live-toggle')) { if (elapsed() >= run.total) { run.elapsed = 0; run.idx = -1; } setRunning(!run.running); if (!run.running) draw(); else keepAwake(); }
  });
  if (mini) mini.addEventListener('click', function (e) {
    if (e.target.closest('[data-mini-stop]')) stopMode();
    else if (e.target.closest('[data-mini-toggle]')) {
      if (elapsed() >= run.total) { stopMode(); return; }
      setRunning(!run.running); if (!run.running) draw(); else keepAwake();
    }
    else if (e.target.closest('[data-mini-open]')) { lastFocus = document.activeElement; showMode(); draw(); }
  });
  mode.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-mode-close') || b.hasAttribute('data-mode-finish')) closeMode();
    else if (b.hasAttribute('data-mode-toggle')) setRunning(!run.running);
    else if (b.hasAttribute('data-mode-restart')) { setRunning(false); run.elapsed = 0; run.idx = -1; draw(); setRunning(true); }
    else if (b.hasAttribute('data-mode-sound')) { sound = !sound; store.set('sk-brew-sound', sound); b.setAttribute('aria-pressed', String(sound)); }
  });
  document.addEventListener('keydown', function (e) {
    if (mode.hidden) return;
    if (e.key === 'Escape') closeMode();
    if (e.key === ' ' && e.target === document.body) { e.preventDefault(); setRunning(!run.running); }
  });
})();
